// ArChat Layout Fix
// Created: 12-03-2026 17:33:56
// Author: SIVOL® - Aldo Frias - Argentina

import { PRESET_LOCALES } from '../presencePresetI18n.js';

export const translationsPt = {
                'login.title': 'Entrar',
                'login.slogan': 'Conversas sem fronteiras!',
                'login.username': 'Nome de usuário',
                'login.password': 'Senha',
                'login.submit': 'Entrar',
                'login.loading': 'Carregando...',
                "login.autoRegister.title": "Registro Automático",
                'login.autoRegister.description': 'Se você não tem uma conta, digite seu nome de usuário, senha e email. Será criada automaticamente e você receberá um link de confirmação por email.',
                'login.forgotPassword': 'Esqueceu sua senha?',
                'login.passwordRecovery.title': 'Recuperar Senha',
                'login.passwordRecovery.description': 'Digite seu email para receber um link de recuperação.',
                "login.passwordRecovery.emailLabel": "E-mail",
                'login.passwordRecovery.emailPlaceholder': 'Digite seu email',
                'login.passwordRecovery.emailHelp': 'Um link de recuperação será enviado para seu email',
                "login.passwordRecovery.send": "Enviar",
                'login.passwordRecovery.success': 'Um link de recuperação foi enviado para seu email. Verifique sua caixa de entrada.',
                'login.passwordRecovery.successTitle': 'E-mail enviado',
                'login.passwordRecovery.successMessage': 'Enviamos um e-mail com as instruções para redefinir sua senha.\nVerifique sua caixa de entrada e a pasta de spam. O link pode levar alguns minutos.',
                'login.passwordRecovery.devExplanation': 'Em modo de desenvolvimento o e-mail não é enviado à sua caixa; é salvo para visualização. Use "Ver e-mail" para ver o conteúdo e o link de recuperação.',
                'login.passwordRecovery.devSinkNotice': '⚠️ Modo desenvolvimento: este e-mail NÃO foi enviado à sua caixa. Use "Ver e-mail" para abrir a mensagem gerada e o link.',
                'login.passwordRecovery.invalidEmail': 'Por favor, digite um email válido',
                'login.error.invalidPassword': 'Senha inválida',
                'login.email.invalid': 'Por favor, digite um email válido',
                "common.language": "Linguagem",
                'common.loading': 'Carregando…',
                'common.back': 'Voltar',
                'common.backToStart': 'Voltar ao início',
                'common.changeUser': 'Mudar usuário',
                'captcha.solve': 'Por favor, resolva o CAPTCHA corretamente',
                'captcha.generateError': 'Erro ao gerar CAPTCHA. Recarregue a página.',
                'auth.require_email': 'E-mail é necessário para completar o registro. Por favor, informe seu e-mail.',
                'auth.invalid_credentials': 'Usuário ou senha incorretos.',
                'auth.account_blocked': 'Conta inativa. Informe seu e-mail para reativar.',
                'auth.device_limit_reached': 'Limite de dispositivos atingido. Encerre sessão em outro dispositivo ou faça upgrade do plano.',
                'auth.login.device_limit.title': 'Limite de sessões ou dispositivos',
                'auth.login.device_limit.body': 'Seu plano permite um número limitado de sessões ou dispositivos ativos ao mesmo tempo. Para entrar, encerre a sessão em outro dispositivo ou feche outra sessão ativa e tente novamente.',
                'auth.password_incorrect': 'A senha está incorreta.',
                'auth.login.password_error_title': 'Senha incorreta',
                'auth.login.password_attempts_hint': 'Você tem 3 tentativas para inserir sua senha corretamente. Se ultrapassar essas tentativas, precisará redefinir sua senha.',
                'auth.login.password_attempts_exhausted_title': 'Limite de tentativas atingido',
                'auth.login.password_attempts_exhausted_body': 'Você excedeu as 3 tentativas permitidas. Para continuar, redefina sua senha em "Esqueceu sua senha?".',
                'auth.login.go_to_reset_password': 'Ir para redefinir senha',
                'auth.login.password_remaining_two': 'Restam 2 tentativas.',
                'auth.login.password_remaining_one': 'Resta 1 tentativa.',
                'auth.login.password_attempts_locked_inline': 'Você atingiu o número máximo de tentativas. É preciso redefinir sua senha.',
                'auth.account_inactive_email_mismatch': 'Conta inativa e o e-mail não confere.',
                'auth.captcha_failed': 'CAPTCHA incorreto. Verifique sua resposta.',
                'auth.captcha_expired': 'Sua verificação expirou. Uma nova foi gerada automaticamente.',
                'auth.unauthorized': 'Você não tem permissão para acessar.',
                'auth.generic_error': 'Ocorreu um erro. Tente novamente.',
                'auth.method_not_allowed': 'Método não permitido.',
                'auth.invalid_data': 'Dados inválidos.',
                'auth.credentials_required': 'Usuário e senha são obrigatórios.',
                'auth.csrf_invalid': 'Sessão inválida. Recarregue a página e tente novamente.',
                'auth.username_taken': 'Esse nome de usuário já está registrado. Faça login ou escolha outro.',
                'auth.username_unavailable': 'Esse usuário não está disponível.',
                'auth.nick_no_spaces': 'Nicknames cannot contain spaces.',
                'auth.password_too_short': 'A senha deve ter pelo menos 6 caracteres.',
                'auth.rate_limit': 'Muitas tentativas. Aguarde um momento e tente novamente.',
                'auth.confirm_success': 'Conta confirmada com sucesso. Redirecionando ao login...',
                'auth.confirm_already_active': 'Sua conta já está ativa. Você pode entrar.',
                'auth.reset_sent': 'Se o e-mail estiver registrado, você receberá instruções para redefinir sua senha.',
                'auth.reset_token_invalid': 'Link inválido ou ausente.',
                'auth.reset_token_expired': 'Este link expirou. Solicite um novo em "Esqueceu sua senha?".',
                'auth.reset_done': 'Senha atualizada. Você já pode entrar.',
                'auth.reset_fatal': 'Erro ao salvar. Tente novamente mais tarde.',
                'auth.password_mismatch': 'As senhas não coincidem.',
                'resetPassword.page.title': 'Nova senha',
                'resetPassword.page.description': 'Digite sua nova senha (mínimo 6 caracteres).',
                'resetPassword.newPassword': 'Nova senha',
                "resetPassword.newPasswordPlaceholder": "Mínimo 6 caracteres",
                'resetPassword.submit': 'Redefinir senha',
                'resetPassword.success': 'Senha atualizada. Redirecionando ao login...',
                'resetPassword.backToLogin': 'Voltar ao login',

                'account.delete.section_title': 'Eliminar conta',
                'account.delete.description': 'Ao eliminar a sua conta, todos os dados, mensagens, contactos e definições serão removidos permanentemente. Esta ação não pode ser anulada.',
                'account.delete.button': 'Eliminar a minha conta',
                'accountDeletion.title': 'Eliminação de conta e dados',
                'accountDeletion.description': 'Solicite a eliminação da sua conta ArChat e dos dados associados.',
                'accountDeletion.openRequest': 'Solicitar eliminação de conta e dados',
                'account.delete.confirm_title': 'Eliminar conta',
                'account.delete.confirm_message': 'Tem a certeza de que quer eliminar a sua conta? Será enviado um e-mail de confirmação para a sua caixa de entrada. A eliminação é permanente e irreversível.',
                'account.delete.email_sent_title': 'E-mail enviado',
                'account.delete.email_sent': 'Enviámos um e-mail de confirmação. Verifique a caixa de entrada e clique na ligação para confirmar a eliminação.',
                'account.delete.error': 'Não foi possível processar o pedido. Tente novamente.',
                'account.delete.confirm_page_title': 'Confirmar eliminação da conta',
                'account.delete.confirm_page_desc': 'Está prestes a eliminar permanentemente a sua conta ArChat. Todos os dados, mensagens, contactos e definições serão removidos. Esta ação não pode ser anulada.',
                'account.delete.confirm_final_button': 'Sim, eliminar a minha conta permanentemente',
                'account.delete.cancel_go_back': 'Cancelar e voltar',
                'account.delete.done_title': 'Conta eliminada',
                'account.delete.done_message': 'A sua conta foi eliminada com sucesso. Todos os dados foram removidos.',
                'account.delete_token_expired': 'A ligação de eliminação expirou ou já não é válida. Solicite uma nova no seu perfil.',
                'account.delete_token_invalid': 'Ligação de eliminação inválida ou em falta.',
                'account.delete_email_failed': 'Não foi possível enviar o e-mail de confirmação. Tente mais tarde.',
                'account.delete_error': 'Erro ao processar a eliminação. Tente mais tarde.',

                'auth.register_success_email_sent': 'Conta criada com sucesso. Um e-mail de confirmação foi enviado. Verifique sua caixa de entrada (e pasta de spam) e clique no link para ativar sua conta.',
                'auth.register_success_email_pending': 'Conta criada com sucesso, mas houve um problema ao enviar o e-mail de confirmação. O token de ativação ainda é válido. Entre em contato com o administrador ou solicite um novo e-mail de confirmação.',
                'auth.email_not_verified': 'Você deve confirmar seu e-mail para ativar a conta.',
                'auth.email_not_verified_title': 'Conta pendente de confirmação',
                'auth.email_send_failed': 'Não foi possível enviar o e-mail agora. Tente novamente ou altere o e-mail.',
                'auth.email_send_failed_title': 'Não foi possível enviar o e-mail',
                'auth.register.email_failed.title': 'Conta criada',
                'auth.register.email_failed.message': 'Sua conta foi criada com sucesso, mas houve um problema ao enviar o e-mail de confirmação. Verifique o spam ou solicite um novo e-mail.',
                'auth.register.success.title': 'Conta criada',
                'auth.register.success.message': 'Conta criada com sucesso. Um e-mail de confirmação foi enviado. Verifique sua caixa de entrada (e pasta de spam) e clique no link para ativar sua conta.',
                'auth.resend_sent': 'E-mail de confirmação reenviado.',
                'auth.resend_email': 'Reenviar e-mail',
                'auth.retry_resend': 'Tentar novamente',
                'auth.change_email': 'Alterar e-mail',
                'auth.ver_email': 'Ver e-mail',
                'auth.already_verified': 'A conta já está verificada.',
                "auth.confirm_email_title": "Confirmar e-mail",
                'auth.confirm_email_text': 'O link de ativação será enviado para:',
                "auth.confirm_email_edit": "Editar",
                "auth.confirm_email_confirm": "Confirmar",
                'auth.confirm_email_typo_hint': 'Quis dizer ***@{suggestion}?',
                'brand.slogan': 'O poder de ser compreendido, independentemente do idioma',
                "brand.appName": "ArChat®",
                "brand.name": "ArChat®",
                "home.title": "ArChat®",
                'home.slogan': 'O poder de ser compreendido, independentemente do idioma',
                'home.tagline': 'Mensagens com tradução automática',
                'home.login': 'Entrar',
                'home.register': 'Criar conta',
                "home.language": "Linguagem",
                'terms.title': 'Termos e Condições',
                'terms.accept': 'Aceitar e Continuar',
                'terms.reject': 'Rejeitar',
                'terms.rejectShort': 'Não aceito',
                'terms.readAndAccept': 'Li e aceito os Termos e Condições',
                "terms.cancel": "Cancelar",
                'register.pageTitle': 'Criar conta',
                'register.pageSubtitle': 'Preencha seus dados para criar sua conta.',
                'register.submitLabel': 'Criar conta',
                'register.confirm_title': 'Confirmar conta',
                'register.confirm_message': 'Você está prestes a criar a conta:',
                "register.confirm": "Confirmar",
                'register.login_link': 'Já tem uma conta?',
                "register.password_hint": "Mínimo 6 caracteres",
                "register.checking": "Verificando…",
                'register.username_taken': 'Este nome de usuário já está em uso.',
                'register.available': 'Disponível',
                'register.emailAlreadyExists': 'Este e-mail já está registrado.',
                "register.continue": "Continuar",
                'common.request_id_label': 'ID da solicitação',
                'login.demo.title': 'Acesso Demo',
                'login.demo.credentials': 'Usuário: demo / Senha: demo',
                'captcha.label': 'Verificação de Segurança',
                'security.verification_title': 'Verificação de segurança',
                'security.captcha_question': 'Pergunta de verificação',
                'security.enter_answer': 'Digite a resposta',
                'captcha.description': 'Resolva a operação matemática para verificar que você é humano',
                'captcha.required': 'Você precisa inserir a resposta do CAPTCHA para continuar.',
                'menu.conversations': 'Conversas',
                'menu.contacts': 'Contatos',
                'menu.dashboard': 'Painel de Controle',
                'menu.profile': 'Meu Perfil',
                'menu.settings': 'Configurações',
                'menu.help': 'Ajuda',
                'menu.logout': 'Sair',
                'menu.files': 'Meus arquivos',
                'reviews.menu_title': 'Avaliações',
                'reviews.rate_archat': 'Avaliar o ArChat',
                'reviews.my_review': 'Minha avaliação',
                'navbar.contacts': 'Contatos',
                'navbar.profile': 'Meu Perfil',
                'navbar.settings': 'Configurações',
                'navbar.logout': 'Sair',
                "navbar.status": "Estado",
                'navbar.users': 'Usuários',
                'navbar.no_blocked_users': 'Não há usuários bloqueados',
                'navbar.blocked_users_title': 'Usuários bloqueados',
                'contacts.blocked_users_title': 'Usuários bloqueados',
                "contacts.country_label": "País",
                'contacts.not_reported': 'Não informado',
                'navbar.user_fallback': 'Usuário {id}',
                'onboarding.welcome_title': 'Bem-vindo ao ArChat®',
                'onboarding.welcome_subtitle': 'Comunique-se com qualquer pessoa em qualquer idioma.',
                'onboarding.step1': 'Passo 1',
                'onboarding.step1_title': 'Passo 1',
                'onboarding.step1_description': 'Convide seu primeiro contato',
                'onboarding.step2': 'Passo 2',
                'onboarding.step2_title': 'Passo 2',
                'onboarding.step2_description': 'Envie sua primeira mensagem',
                'onboarding.invite_contact': 'Convidar contato',
                "onboarding.explore_archat": "Explorar ArChat®",
                'help.how_archat_works': 'Como o ArChat® funciona',
                "help.registration": "Registro",
                'help.private_invitations': 'Convites privados',
                'help.messaging': 'Mensagens',
                'help.security': 'Segurança',
                'contacts.invite_contact': 'Convidar contato',
                'contacts.no_contacts': 'Sem contatos',
                'help.view_initial_guide': 'Ver guia inicial',
                'suggestions.title': 'Sugestões',
                'suggestions.form.title': 'Título da sugestão',
                'suggestions.form.message': 'Descreva sua ideia',
                'suggestions.form.submit': 'Enviar sugestão',
                'suggestions.send': 'Enviar sugestão',
                "suggestions.captcha_placeholder": "Resultado",
                'suggestions.cooldown': 'Você deve esperar {minutes} minutos antes de enviar outra sugestão.',
                'suggestions.success_title': 'Sugestão enviada',
                'suggestions.success_message': 'Sua sugestão foi enviada com sucesso. Número de acompanhamento: {id}',
                'suggestions.success': 'Obrigado pela sua sugestão. Nossa equipe irá analisá-la.',
                'suggestions.success.title': 'Obrigado pela sua sugestão!',
                'suggestions.success.reference': 'Referência',
                'suggestions.success.review': 'Nossa equipe analisará sua ideia.',
                'suggestions.success.email': 'Também enviamos um email de confirmação para você.',
                "suggestions.success.copy": "Cópia",
                'suggestions.success.copied': 'Referência copiada',
                'suggestions.form.required': 'Título e mensagem são obrigatórios.',
                'suggestions.error': 'Não foi possível enviar. Tente novamente.',
                'profile.title': 'Meu Perfil',
                "profile.founderBadge": "Fundador #{posição}/{limit}",
                'profile.founderTooltip': 'Membro Fundador – Preço congelado por toda a vida enquanto a assinatura permanecer ativa',
                'profile.founderMember': 'Membro Fundador',
                "profile.founderHeaderBadge": "★ Fundador #{posição}/150",
                'profile.camera.access_denied': 'Não foi possível acessar a câmera. Verifique as permissões.',
                "profile.edit": "Editar",
                'profile.save': 'Salvar Alterações',
                'profile.save.success': 'Seu perfil foi atualizado com sucesso.',
                'profile.save.success.title': 'Perfil Atualizado',
                'profile.update.success.title': 'Perfil Atualizado',
                'profile.update.success.message': 'As suas alterações foram guardadas.',
                'profile.save.error': 'Não foi possível atualizar o perfil. Por favor, tente novamente.',
                'profile.save.error.title': 'Erro ao Salvar',
                "profile.cancel": "Cancelar",
                'profile.nick': 'Nome de usuário',
                'profile.nick.help': 'Seu identificador único no sistema',
                'profile.nick.readonly': 'O nome de usuário não pode ser modificado',
                'profile.nick.readonly.help': 'O nome de usuário é único e não pode ser modificado',
                'profile.email.readonly': 'O email não pode ser modificado',
                'profile.email.readonly.help': 'O email é único e não pode ser modificado',
                'profile.name': 'Nome Real',
                'profile.lastname': 'Sobrenome',
                'profile.alias': 'Apelido',
                "profile.email": "E-mail",
                'profile.phone': 'Telefone',
                "profile.language": "Linguagem",
                "profile.country": "País",
                'profile.country.select': 'Selecionar país',
                'profile.biography': 'Biografia',
                "bio.modal.original": "Original",
                'bio.modal.translation': 'Tradução',
                'bio.modal.empty': 'Este contacto não tem biografia.',
                'bio.modal.translating': 'A traduzir...',
                'bio.modal.translation_error': 'Não foi possível traduzir a biografia.',
                'attachment.unnamed_file': 'Ficheiro',
                'auth.login_error.default_title': 'Erro de acesso',
                'auth.login_error.default_message': 'Não foi possível iniciar sessão.',
                "profile.photo": "Foto do perfil",
                'notifications.bell.aria': 'Notificações',
                'notifications.panel.title': 'Notificações',
                'notifications.empty': 'Sem notificações',
                'notifications.mark_read': 'Marcar como lida ao abrir',
                'profile.plan.expires': 'Expira em',
                'profile.plan.loading_info': 'Carregando informações do plano...',
                'profile.plan.valid_until': 'Válido até:',
                'profile.plan.active_since': 'Ativo desde:',
                'profile.plan.active_badge': '✓ Ativo',
                'profile.plan.upgrade.button': 'Atualizar para PRO',
                'profile.plan.upgrade.hint': 'Acesse todas as funções sem limites',
                'billing.change_plan': 'Mudar de plano',
                'billing.usage.title': 'Uso do plano',
                'billing.usage.users': 'Usuários',
                'billing.usage.messages': 'Mensagens (hoje)',
                'billing.usage.invitations': 'Convites (hoje)',
                'billing.usage.messages_month': 'Mensagens este mês',
                'billing.usage.chats': 'Conversas',
                'billing.usage.warning': 'Você está se aproximando do limite do seu plano. Atualize para PRO para mais capacidade.',
                'plans.limit.reached': 'Limite atingido — Melhorar plano',
                'profile.theme.dark': 'Modo Escuro',
                "profile.theme.light": "Modo Limpar",
                "profile.theme.argentina": "Tema Argentina",
                "modal.title": "Qualificação",
                'modal.success.title': 'Sucesso',
                'modal.error.title': 'Erro',
                'modal.warning.title': 'Aviso',
                'info.title': 'Informação',
                'appearance.title': 'Aparência',
                "appearance.theme.light": "Claro",
                'appearance.theme.dark': 'Escuro',
                "theme.title": "Emitir",
                "theme.light": "Claro",
                'theme.dark': 'Escuro',
                'profile.photo.section': 'Foto do perfil',
                'profile.personalInfo': 'Informações Pessoais',
                'profile.preferences': 'Preferências',
                'profile.photo.change': 'Alterar foto de perfil',
                'message.placeholder': 'Escreva uma mensagem...',
                'message.placeholderWithFile': 'Enviar arquivo',
                'message.sent_from_country': 'Enviado de',
                'message.sent_at_local_time': 'Hora local do remetente',
                'message.timezone_label': 'Fuso horário',
                'message.context_info': 'Esta mensagem preserva o contexto horário do momento em que foi enviada.',
                'message.context_pro_hint': 'Esta mensagem inclui contexto de hora e local do remetente em planos Pro.',
                "message.context_pro_badge": "Contexto Profissional",
                'message.audio.transcribe': 'Transcrever áudio',
                'message.audio.transcribing': 'Transcrevendo...',
                'message.audio.transcription': 'Transcrição',
                'message.audio.error': 'Não foi possível transcrever o áudio',
                'attachment.title': 'Anexar Arquivo',
                'attachment.close': 'Fechar',
                'attachment.gallery': 'Galeria de fotos/vídeos',
                'attachment.cameraFront': 'Câmera frontal',
                'attachment.cameraBack': 'Câmera traseira',
                'attachment.cameraWeb': 'Câmera web',
                'attachment.selectFile': 'Selecionar arquivo (PDF, texto, imagens, vídeos)',
                'attachment.remove': 'Remover',
                'attachments.recipientFreeBlocked.title': 'Limite do plano',
                'attachments.recipientFreeBlocked.sender': 'Este utilizador está no plano Free e não pode receber anexos.',
                'attachments.recipientFreeBlocked.receiver': '{senderName} tentou enviar-te um anexo, mas o teu plano {planName} não permite receber anexos. Recomendamos um plano superior para receber ficheiros.',
                'attachments.recipientFreeBlocked.upgradeCta': 'Melhorar plano',
                'attachment.audioNotSupported': 'Mensagens de áudio não são compatíveis com ArChat®. Por favor, envie uma mensagem escrita.',
                'message.audioDeprecated.title': 'Mensagem de voz não compatível',
                'message.audioDeprecated.message': 'Esta mensagem de voz não é mais compatível com ArChat®. Por favor, envie uma mensagem escrita.',
                'camera.title': 'Câmera',
                'camera.close': 'Fechar',
                'camera.switch': 'Trocar câmera',
                'camera.capture': 'Tirar Foto',
                'camera.loading': 'Iniciando câmera...',
                'camera.retry': 'Tentar novamente',
                'camera.error.access': 'Não foi possível acessar a câmera. Verifique as permissões.',
                'camera.error.permission': 'Permissões da câmera negadas. Por favor, permita o acesso à câmera nas configurações do navegador.',
                'camera.error.notFound': 'Nenhuma câmera encontrada.',
                'camera.error.busy': 'A câmera está sendo usada por outro aplicativo.',
                'camera.error.constraint': 'As restrições da câmera não podem ser satisfeitas.',
                'profile.photo.take': 'Tirar foto',
                'profile.photo.gallery': 'Escolher da galeria',
                'profile.photo.select': 'Selecionar foto',
                'profile.photo.select.gallery': 'Escolher da galeria',
                'profile.photo.uploading': 'Enviando imagem...',
                'profile.photo.upload.success': 'Foto de perfil atualizada com sucesso',
                'profile.photo.upload.success.title': 'Foto Atualizada',
                'profile.photo.upload.error': 'Erro ao enviar foto de perfil. Por favor, tente novamente.',
                'profile.photo.upload.error.title': 'Erro ao Enviar Foto',
                'profile.photo.take.front': 'Câmera frontal',
                'profile.photo.take.back': 'Câmera traseira',
                "profile.photo.take.webcam": "Webcam",
                "profile.photo.capture": "Capturar",
                'profile.country.help': 'O fuso horário será atribuído automaticamente de acordo com o país selecionado',
                'profile.lastname.placeholder': 'Seu sobrenome (opcional)',
                'profile.name.placeholder': 'Seu nome real (opcional)',
                'profile.biography.placeholder': 'Conte-nos sobre você...',
                'profile.notifications.sound': 'Som de notificações',
                'profile.notifications.sound_desc': 'Reproduzir som quando chegarem mensagens ou avisos importantes',
                'profile.plan.title': 'Plano de Assinatura',
                'profile.plan.current': 'Plano Atual',
                'profile.plan.free.description': 'Plano gratuito com limitações. Atualize para PRO para acesso completo.',
                'profile.plan.pro.description': 'Você tem acesso completo a todas as funcionalidades.',
                'user.default': 'Usuário',
                "logout.title": "Confirmar",
                'logout.confirm': 'Tem certeza de que deseja sair?',
                'contacts.title': 'Contatos',
                'contacts.search': 'Buscar contato',
                'contacts.search.placeholder': 'Buscar por nome de usuário, nome, sobrenome, país ou idioma...',
                "contacts.sort": "Ordem",
                'contacts.sortByName': 'Por nome',
                "contacts.sortByStatus": "Por estado",
                'contacts.sortByRecent': 'Mais recentes',
                "contacts.filter": "Filtro",
                "contacts.filterAll": "Todos",
                'contacts.filterAvailable': 'Disponíveis',
                'contacts.filterInvited': 'Convidados',
                "contacts.filterBlocked": "Bloqueado",
                'contacts.pending_invitations': 'Convites pendentes',
                'contacts.status.invitation_sent': 'Convite enviado',
                'contacts.empty': 'Não há contatos',
                'contacts.empty.title': 'Você ainda não tem contatos',
                'contacts.empty.message': 'Convide ou adicione um para começar a conversar.',
                'contacts.empty.invite_button': 'Convidar um contato',
                'contacts.empty.private.message': 'Seu perfil é privado. Convide contatos para começar a conversar.',
                'contacts.empty.private.invite_button': 'Convidar um contato',
                'contacts.search.no_results': 'Nenhum contato encontrado',
                "contacts.search.clear": "Mostrar tudo",
                'contacts.controls.search_placeholder': 'Buscar contato...',
                'contacts.controls.search_label': 'Buscar contato',
                "contacts.controls.sort_label": "ordenar por",
                'contacts.controls.sort.name': 'Nome',
                "contacts.controls.sort.status": "Estado",
                'contacts.controls.sort.recent': 'Recente',
                "contacts.controls.sort.manual": "Manual",
                'contacts.controls.sort.manual_drag_hint': 'Arrastar para reordenar',
                "contacts.controls.filter_label": "Estado",
                "contacts.controls.filter.all": "Todos",
                'contacts.controls.filter.available': 'Disponíveis',
                'contacts.controls.filter.invited': 'Convidados',
                "contacts.controls.filter.blocked": "Bloqueado",
                "contacts.controls.filter.favorites": "Favoritos",
                'contacts.nick': 'Nome de usuário',
                'contacts.name': 'Nome',
                'contacts.lastname': 'Sobrenome',
                "contacts.country": "País",
                "contacts.language": "Linguagem",
                "contacts.status": "Estado",
                'status.available': 'Disponível',
                "status.busy": "Ocupado",
                'status.in_call': 'Em chamada',
                "status.away": "Ausente",
                "status.offline": "Off-line",
                'status.custom': 'Mensagem personalizada',
                'status.set_title': 'Estado de disponibilidade',
                'status.set_button': 'Alterar estado',
                'status.placeholder': 'Mensagem opcional (ex: Em reunião)',
                'contacts.status.pending_registration': 'Pendente de registro',
                'contacts.status.registered': 'Convidado - Registrado',
                'contacts.status.ready_to_chat': 'Pronto para conversar',
                'contacts.status.active_conversation': 'Conversa ativa',
                'contacts.invitation.pending.title': 'Convite Pendente',
                'contacts.invitation.pending.message': 'Este convite está pendente de registro. O contato receberá um email para completar seu cadastro. Uma vez registrado, você poderá conversar com ele.',
                'contacts.error.no_registered': 'O contato ainda não está registrado. Aguarde que ele complete seu registro.',
                'contact.edit.title': 'Editar Contato',
                'contact.edit.alias.label': 'Apelido personalizado',
                'contact.edit.alias.placeholder': 'Ex: João do trabalho',
                'contact.edit.alias.help': 'Este nome aparecerá no lugar do nome real',
                'contact.edit.nota.label': 'Nota pessoal',
                'contact.edit.nota.placeholder': 'Adicione uma nota sobre este contato...',
                'contact.edit.nota.help': 'Notas privadas visíveis apenas para você',
                'contact.edit.error.noUser': 'Erro: Usuário não identificado',
                'contact.edit.error.noContactId': 'Erro: Não foi possível identificar o contato',
                'contact.edit.error.save': 'Erro ao salvar',
                'contact.limit.title': 'Limite de contatos atingido',
                'contact.limit.message': 'O plano FREE permite até 2 contatos por usuário. Atualize para FOUNDATION ou PRO para mais capacidade quando o pagamento estiver habilitado.',
                'contact.edit.info.personalized': 'Essas alterações são personalizadas apenas para você e não afetam outros usuários.',
                'contact.edit.profileInfo': 'Informações do Perfil',
                'export.title': 'Exportar Conversa',
                'export.description': 'Selecione o formato em que deseja exportar esta conversa:',
                "export.progress": "Exportador...",
                "export.format.pdf": "PDF",
                'export.format.pdf.description': 'Documento PDF com todas as imagens e arquivos',
                "export.format.html": "HTML",
                'export.format.html.description': 'Arquivo HTML que você pode abrir em qualquer navegador',
                'export.info': 'A exportação incluirá todas as mensagens, imagens e arquivos desta conversa.',
                'export.pro_required.title': 'Exportar conversa',
                'export.pro_required.message': 'Esta funcionalidade está disponível no plano PRO.',
                'invitation.title': 'Convidar Contato por Email',
                'invitation.modal.title': 'Enviar Convite',
                'invitation.modal.description': 'Convide alguém para conversar com você no ArChat®. Eles receberão um email com um link para aceitar o convite.',
                'invitation.email.label': 'Email do Convidado',
                'invitation.email.placeholder': 'exemplo@email.com',
                'invitation.email.required': 'O email é obrigatório',
                'invitation.email.invalid': 'Por favor, insira um email válido',
                'invitation.language.label': 'Idioma Preferido do Convidado',
                'invitation.language.help': 'O email será enviado neste idioma',
                'invitation.mode.label': 'Modo de Conversa',
                'invitation.mode.profesional': 'Profissional',
                'invitation.mode.profesional.description': 'Conversa formal e profissional',
                "invitation.mode.tecnico": "Técnico",
                'invitation.mode.tecnico.description': 'Conversa técnica e especializada',
                "invitation.mode.casual": "Casual",
                'invitation.mode.casual.description': 'Conversa informal e amigável',
                'invitation.message.label': 'Mensagem Pessoal (opcional)',
                'invitation.message.placeholder': 'Escreva uma mensagem pessoal para o convidado...',
                'invitation.send': 'Enviar Convite',
                "invitation.sending": "Enviando...",
                'invitation.success': 'Convite enviado com sucesso',
                'invitation.error': 'Erro ao enviar convite',
                'invitation.error.self': 'Você não pode se convidar',
                'invitation.error.duplicate': 'Já existe um convite pendente para este email',
                'invitation.list.title': 'Convites Enviados',
                'invitation.list.empty': 'Você não enviou nenhum convite',
                "invitation.list.email": "E-mail",
                "invitation.list.language": "Linguagem",
                "invitation.list.mode": "Modo",
                "invitation.list.status": "Estado",
                'invitation.list.created': 'Enviado',
                "invitation.list.expires": "Expira",
                'invitation.list.actions': 'Ações',
                'invitation.status.pending': 'Pendente',
                'invitation.status.accepted': 'Aceito',
                'invitation.status.expired': 'Expirado',
                'invitation.status.cancelled': 'Cancelado',
                'invitation.copy.link': 'Copiar Link',
                'invitation.copy.success': 'Link copiado para a área de transferência',
                "invitation.cancel": "Cancelar",
                'invitation.cancel.confirm': 'Tem certeza de que deseja cancelar este convite?',
                'invitation.cancel.success': 'Convite cancelado com sucesso',
                'invitation.cancel.title': 'Confirmar Cancelamento',
                "invitation.resend": "Encaminhar e-mail",
                'invitation.resend.title': 'Reenviar Convite',
                'invitation.resend.success': 'Email de convite reenviado com sucesso',
                'invitation.resend.error': 'Erro ao reenviar email de convite',
                'invitation.accept.title': 'Aceitar Convite',
                'invitation.accept.description': 'Você foi convidado para conversar no ArChat®',
                'invitation.accept.inviter': 'Convidado por',
                'invitation.accept.message': 'Mensagem pessoal',
                'invitation.accept.login': 'Entrar',
                'invitation.accept.register': 'Registrar',
                'invitation.accept.error.invalid': 'Token de convite inválido',
                'invitation.accept.error.expired': 'Este convite expirou',
                'invitation.accept.error.accepted': 'Este convite já foi aceito',
                'invitation.accept.error.cancelled': 'Este convite foi cancelado',
                'invitation.accept.error.email_mismatch': 'O email da sua conta não corresponde ao email do convite',
                'invitation.accept.success': 'Convite aceito. Redirecionando para o chat...',
                'invitations.sent.title': 'Convites enviados',
                'invitations.sent.empty': 'Nenhum convite pendente',
                'invitations.pending.title': 'Convites pendentes',
                "invitations.columns.email": "E-mail",
                "invitations.columns.language": "Linguagem",
                "invitations.columns.mode": "Modo",
                "invitations.columns.status": "Estado",
                'invitations.columns.sentAt': 'Enviado',
                'invitations.columns.actions': 'Ações',
                'invitations.status.pending': 'Pendente',
                'invitations.status.accepted': 'Aceito',
                'invitations.status.cancelled': 'Cancelado',
                'invitations.status.expired': 'Expirado',
                "invitations.actions.cancel": "Cancelar",
                'invitations.actions.copy': 'Copiar link',
                "invitations.actions.resend": "Encaminhar e-mail",
                'profile.privacy.title': 'Privacidade',
                'profile.privacy.public_visibility': 'Tornar meu perfil publicamente visível',
                'profile.privacy.public_warning': 'Isso permite que qualquer usuário do ArChat® possa encontrá-lo e iniciar uma conversa.',
                'profile.privacy.private_info': 'Seu perfil é privado. Apenas usuários que você convidar ou que o convidarem poderão conversar com você.',
                'profile.privacy.private_default': 'Por padrão, seu perfil é privado para maior segurança.',
                'common.close': 'Fechar',
                "common.sending": "Enviando...",
                "common.cancel": "Cancelar",
                "common.confirm": "Confirmar",
                'common.save': 'Salvar',
                'common.saving': 'Salvando...',
                'buttons.accept': 'Aceitar',
                "buttons.cancel": "Cancelar",
                'buttons.save': 'Salvar',
                "buttons.edit": "Editar",
                'buttons.retry': 'Tentar novamente',
                "buttons.confirm": "Confirmar",
                'buttons.yes': 'Sim',
                'buttons.no': 'Não',
                "buttons.send": "Enviar",
                'buttons.close': 'Fechar',
                "buttons.continue": "Continuar",
                'buttons.delete': 'Excluir',
                'buttons.logout': 'Sair',
                'buttons.back': 'Voltar',
                'buttons.update': 'Atualizar',
                'buttons.upload': 'Enviar',
                'buttons.select': 'Selecionar',
                'conversation.backToContacts': 'Voltar para contatos',
                'help.title': 'Ajuda do ArChat®',
                'help.howWorks.title': '👥 Como funciona o ArChat® (fluxo real)',
                "help.howWorks.step1.title": "1️⃣ Cadastro",
                'help.howWorks.step1.point1': 'Faça login com seu apelido e senha.',
                'help.howWorks.step1.point2': 'Se você não tiver uma conta, ela será criada automaticamente.',
                'help.howWorks.step1.point3': 'Você aceita os Termos e Condições no seu idioma.',
                'help.howWorks.step1.point4': 'Você confirma sua conta por email.',
                'help.howWorks.step2.title': '2️⃣ Convites privados',
                'help.howWorks.step2.point1': 'Convide contatos por email do seu perfil.',
                'help.howWorks.step2.point2': 'Defina o idioma e o modo de conversa antes de começar.',
                'help.howWorks.step2.point3': 'O contato recebe um convite privado.',
                'help.howWorks.step2.point4': 'Você pode ver se está: Pendente, Registrado, Pronto para conversar',
                'help.howWorks.step2.point5': 'Os contatos não são pesquisados, são convidados.',
                'help.howWorks.step2.point6': 'Os contatos não são pesquisados, são convidados.',
                'help.howWorks.step3.title': '3️⃣ Contatos e conversas',
                'help.howWorks.step3.point1': 'Seus contatos aparecem automaticamente quando:',
                'help.howWorks.step3.point2': 'aceitam um convite',
                'help.howWorks.step3.point3': 'ou existe uma conversa',
                'help.howWorks.step3.point4': 'Você pode:',
                'help.howWorks.step3.point5': 'marcá-los como favoritos ⭐',
                'help.howWorks.step3.point6': 'atribuir aliases personalizados',
                'help.howWorks.step3.point7': 'adicionar notas privadas',
                'help.howWorks.step3.point8': 'bloqueá-los ou gerenciá-los',
                'help.howWorks.step3.point9': 'Não há agenda pública nem usuários visíveis sem consentimento.',
                'help.howWorks.step4.title': '4️⃣ Mensagens com tradução',
                'help.howWorks.step4.point1': 'Sempre escreva no seu idioma.',
                'help.howWorks.step4.point2': 'O sistema traduz automaticamente a mensagem.',
                'help.howWorks.step4.point3': 'O destinatário a recebe no seu idioma.',
                'help.howWorks.step4.point4': 'Você pode ver a tradução aplicada.',
                'help.howWorks.step4.point5': 'Se uma tradução falhar, ela é tentada automaticamente novamente.',
                'help.howWorks.step4.point6': 'ArChat® prioriza clareza e significado, não apenas velocidade.',
                'help.privacy.title': '🔒 Privacidade e controle',
                'help.privacy.point1': 'Seu perfil é privado por padrão.',
                'help.privacy.point2': 'Apenas quem você convidar pode vê-lo ou escrever para você.',
                'help.privacy.point3': 'A visibilidade pública é opcional e desativada por padrão.',
                'help.privacy.point4': 'Segurança ativa com:',
                "help.privacy.point5": "CAPTCHA",
                'help.privacy.point6': 'limitação de taxa',
                'help.privacy.point7': 'impressão digital',
                'help.privacy.point8': 'verificação por email',
                'help.privacy.point9': 'Suas conversas não são públicas nem indexadas.',
                'help.files.title': '📎 Arquivos e exportação',
                'help.files.point1': 'Anexe imagens, vídeos e documentos PDF.',
                'help.files.point2': 'Capture fotos com câmera frontal, traseira ou webcam.',
                'help.files.point3': 'As imagens são comprimidas automaticamente.',
                'help.files.point4': 'Visualização antes de enviar.',
                'help.files.point5': 'Barra de progresso durante o upload.',
                'help.files.point6': 'Exporte conversas completas para:',
                "help.files.point7": "PDF",
                "help.files.point8": "HTML",
                'help.files.point9': 'Inclui mensagens, imagens e arquivos.',
                'help.files.point10': 'Seus dados são seus.',
                'help.experience.title': '🎨 Experiência de uso',
                'help.experience.point1': 'Estados de presença e estados personalizados com emoji.',
                "help.experience.point2": "Emojis OpenMoji integrados.",
                'help.experience.point3': 'Indicadores de leitura e digitação.',
                'help.experience.point4': 'Visualização móvel otimizada igual à área de trabalho.',
                'help.experience.point5': 'Aplicativo PWA instalável.',
                'help.experience.point6': 'Dois temas: Argentina (azul claro/branco/dourado) e Escuro (roxo profundo).',
                'help.experience.point7': 'Edição de perfil sem atualizações.',
                'help.experience.point8': 'Seletor de país com fuso horário automático.',
                "help.experience.point9": "Acesso rápido com favoritos, pesquisa e filtros.",
                "help.languages.title": "🌍 Idiomas",
                'help.languages.point1': 'Suporte para {count} idiomas.',
                'help.languages.point2': 'Seletor visual com bandeiras.',
                'help.languages.point3': 'Interface, T&C e emails adaptados ao idioma escolhido.',
                'help.languages.point4': 'Tradução automática bidirecional entre usuários.',
                'help.tipsNew.title': '💡 Dicas para aproveitar o ArChat®',
                'help.tipsNew.point1': 'Convide apenas pessoas com quem você realmente quer se comunicar.',
                'help.tipsNew.point2': 'Use aliases e notas privadas para organizar contatos.',
                'help.tipsNew.point3': 'Marque favoritos para acesso rápido.',
                'help.tipsNew.point4': 'Revise a tradução antes de enviar mensagens importantes.',
                'help.tipsNew.point5': 'Exporte conversas relevantes para backup ou trabalho.',
                'help.tipsNew.point6': 'Use ArChat® quando a clareza escrita for fundamental.',
                'help.whySubscribe.title': '🚀 Por que se inscrever no ArChat®',
                'help.whySubscribe.point1': 'ArChat® não foi projetado para conversar com qualquer pessoa,',
                'help.whySubscribe.point2': 'mas para se comunicar melhor com quem importa.',
                'help.whySubscribe.point3': 'Se você precisar de:',
                'help.whySubscribe.point4': 'clareza entre idiomas',
                'help.whySubscribe.point5': 'privacidade real',
                'help.whySubscribe.point6': 'controle de contatos',
                'help.whySubscribe.point7': 'exportação de conversas',
                'help.whySubscribe.point8': 'uma experiência profissional e sem ruído',
                'help.whySubscribe.point9': 'ArChat® foi projetado para isso.',
                'help.features.title': 'Principais recursos',
                'help.features.translation': '🌐 Tradução automática e instantânea entre idiomas',
                'help.features.status': '💬 Status de presença (Online, Inativo, Não perturbe, etc.)',
                'help.features.statusCustom': '💬 Status personalizados com emoji e mensagem personalizada',
                'help.features.contacts': '👥 Lista completa de contatos com busca, favoritos fixos no topo e bloqueios pelo modal de Usuários',
                'help.features.contactsMobile': '📱 Vista móvel otimizada com estado e aparência na barra superior (igual ao desktop)',
                'help.features.contactsFilter': '👁️ Botão para mostrar/ocultar contatos não favoritos - reduz a lista apenas aos seus favoritos',
                'help.features.contactAlias': '✏️ Alias personalizado e notas privadas para cada contato - clique no nome do contato na conversa',
                'help.features.themes': '🎨 Dois temas disponíveis: Argentina (azul claro/branco/dourado) e Escuro (roxo profundo)',
                'help.features.messages': '📨 Mensagens em tempo real com indicadores de leitura, emojis OpenMoji inline e indicador de digitando visível',
                'help.features.attachments': '📎 Anexar arquivos compatíveis com comunicação escrita: imagens, vídeos e documentos PDF',
                'help.features.camera': '📸 Captura de fotos com câmera frontal, traseira ou webcam',
                'help.features.gallery': '🖼️ Seleção de arquivos da galeria',
                'help.features.compression': '🗜️ Compressão automática de imagens e geração de miniaturas',
                'help.features.progress': '📊 Barra de progresso durante o upload de arquivos',
                'help.features.delete': '🗑️ Eliminação de suas próprias mensagens',
                'help.features.scroll': '⬇️ Scroll automático para a última mensagem ao abrir conversa',
                'help.features.profile': '👤 Perfil personalizável com avatar, biografia e preferências',
                'help.features.profileEdit': '✏️ Edição de perfil sem interrupções (não atualiza enquanto edita)',
                'help.features.countries': '🌍 Lista completa de 195+ países com seleção automática de fuso horário',
                'help.features.registration': '📧 Registro com Termos & Condições obrigatórios antes de criar a conta e confirmação por email',
                'help.features.multilanguage': '🗣️ Suporte para {count} idiomas com bandeiras; T&C e emails traduzidos para o idioma escolhido',
                'help.features.pwa': '📲 Aplicativo PWA instalável em dispositivos móveis e desktop',
                'help.features.sync': '🔄 Sincronização automática de mensagens a cada 5 segundos',
                'help.features.deleteSync': '🗑️ Sincronização automática de mensagens excluídas entre dispositivos',
                'help.features.notifications': '🔔 Notificações sonoras para novas mensagens recebidas',
                'help.features.retranslation': '🔄 Re-tradução automática de mensagens se a primeira tentativa falhar',
                'help.features.preview': '👁️ Visualização de arquivos antes de enviar',
                'help.features.security': '🔒 Sistema de segurança com CAPTCHA, fingerprint, rate limiting e fluxo de T&C obrigatório',
                'help.features.passwordRecovery': '🔑 Recuperação de senha por email',
                'help.features.emailConfirmation': '📧 Confirmação de conta por email com link de ativação',
                'help.features.invitations': '📧 Convites privados por email - Convide contatos externos com idioma e contexto definidos',
                'help.features.invitationsManagement': '📋 Gerenciamento completo de convites - Liste, reenvie ou cancele convites pendentes do menu',
                'help.features.contactStatus': '🏷️ Status de contato visível - Veja o status de cada contato (pendente, registrado, pronto para conversar)',
                'help.features.favorites': '⭐ Sistema de favoritos - Marque contatos como favoritos para acesso rápido',
                'help.features.profilePhoto': '📸 Upload melhorado de foto de perfil - Selecione imagens da galeria com preview imediato',
                'help.features.translationSender': '👁️ Visualização de traduções para o remetente - Veja como sua mensagem foi traduzida para o idioma do destinatário',
                'help.features.unifiedContacts': '🔗 Modelo unificado de contatos - Contatos são derivados de convites e conversas existentes',
                'help.features.privacy': '🔒 Modo privado por padrão - Seu perfil é privado e acessível apenas por convite direto',
                'help.features.export': '💾 Exportação de conversas - Exporte conversas completas para PDF ou HTML com imagens e arquivos',
                'help.tips.title': 'Dicas úteis',
                'help.tips.language': '✅ Defina seu idioma no seletor de {count} bandeiras; T&C e emails seguem esse idioma',
                'help.tips.status': '✅ Atualize seu status de presença para que outros saibam sua disponibilidade',
                'help.tips.statusCustom': '✅ Crie status personalizados com emoji e mensagem para expressar seu estado atual',
                'help.tips.search': '✅ Fixe favoritos (estrela) e bloqueie usuários pelo modal "Usuários"',
                'help.tips.contactsFilter': '✅ Use o botão do olho (👁️) na barra superior para mostrar ou ocultar contatos que não são favoritos',
                'help.tips.contactAlias': '✅ Clique no nome do contato na conversa para adicionar um alias personalizado e notas privadas',
                'help.tips.avatar': '✅ Clique no avatar de um contato para ver sua imagem em tamanho grande',
                'help.tips.messages': '✅ O ícone ArChat® pisca com não lidas; insira emojis com o seletor OpenMoji',
                'help.tips.attachments': '✅ Anexe imagens, vídeos ou PDFs com o clipe (📎); compatível com comunicação escrita',
                'help.tips.camera': '✅ Use a câmera para capturar fotos diretamente do aplicativo',
                'help.tips.compression': '✅ As imagens são comprimidas automaticamente para economizar espaço',
                'help.tips.delete': '✅ Você pode excluir suas próprias mensagens clicando no botão de excluir',
                'help.tips.profile': '✅ Edite seu perfil sem refresh e alterne Argentina / Escuro (tema claro ou escuro).',
                'help.tips.themes': '✅ Altere o tema em Configurações > Aparência: Argentina (azul claro) ou Escuro (roxo profundo)',
                'help.tips.country': '✅ Selecione seu país no perfil para que o fuso horário seja configurado automaticamente',
                'help.tips.registration': '✅ Antes de registrar, aceite os T&C no seu idioma; depois confirme seu email',
                'help.tips.writing': '✅ Escreva mensagens claras: ArChat® traduz o significado do texto escrito, mantendo contexto e clareza',
                'help.tips.install': '✅ Instale o ArChat® como aplicativo PWA em seu dispositivo para acesso rápido da área de trabalho',
                'help.tips.sync': '✅ As mensagens são sincronizadas automaticamente a cada 5 segundos - você não precisa atualizar',
                'help.tips.deleteSync': '✅ Se você excluir uma mensagem, ela será automaticamente excluída em todos os dispositivos do destinatário',
                'help.tips.notifications': '✅ Você ouvirá um som quando receber uma nova mensagem de outro usuário',
                'help.tips.retranslation': '✅ Se uma mensagem não foi traduzida corretamente, o sistema tentará re-traduzi-la automaticamente',
                'help.tips.preview': '✅ Revise a visualização do arquivo antes de enviar para ter certeza de que é o correto',
                'help.tips.passwordRecovery': '✅ Se você esqueceu sua senha, use o link "Esqueceu sua senha?" no login',
                'help.tips.emailConfirmation': '✅ Verifique seu email após se registrar e clique no link de confirmação',
                'help.tips.languageChange': '✅ Altere idioma no seletor de bandeiras: T&C, emails e UI atualizam na hora',
                'help.tips.inputFixed': '✅ No PC, a barra de escrita permanece fixa na parte inferior da tela para maior conforto',
                'help.tips.invitations': '✅ Convide contatos por email do seu perfil - Defina o idioma e modo de conversa desde o início',
                'help.tips.invitationsManagement': '✅ Gerencie seus convites do menu "Convites Enviados" - Reenvie emails ou cancele convites pendentes',
                'help.tips.contactStatus': '✅ Observe o status de cada contato na lista - Pendente (laranja), Registrado (verde) ou Conversa ativa (azul)',
                'help.tips.favorites': '✅ Marque contatos como favoritos com a estrela ⭐ - Favoritos aparecem primeiro na sua lista',
                'help.tips.profilePhoto': '✅ Faça upload da sua foto de perfil de "Escolher da galeria" - Você verá uma preview antes de salvar',
                'help.tips.translationSender': '✅ Ao enviar uma mensagem, expanda o painel de tradução para ver como foi traduzida para o idioma do destinatário',
                'help.tips.unifiedContacts': '✅ Seus contatos são mostrados automaticamente quando aceitam convites ou você tem conversas com eles',
                'help.tips.privacy': '✅ Seu perfil é privado por padrão - Ative a visibilidade pública em Perfil > Privacidade se quiser que outros te encontrem',
                'help.tips.export': '✅ Exporte conversas completas usando o botão ⬇️ no cabeçalho - Escolha PDF ou HTML com todas as imagens',
                'help.support.title': 'Suporte',
                'help.support.description': 'Se você tiver problemas ou perguntas, entre em contato com o administrador do sistema ou revise a documentação técnica disponível.',
                'help.about.title': 'Sobre',
                'help.about.developer': 'Desenvolvido por:',
                "help.about.location": "MDQ-ARGENTINA",
                'help.about.linkedin': 'Ver perfil no LinkedIn',
                'presence.title': 'Estado de Presença',
                'presence.currentStatus': 'Estado atual:',
                'presence.changeStatus': 'Alterar estado',
                "presence.status.online": "On-line",
                'presence.status.online.title': 'Online - Visível para todos',
                'presence.status.online.description': 'Online: Visível para todos os contatos',
                'presence.status.idle': 'Inativo',
                'presence.status.idle.title': 'Inativo - Indica ausência temporária',
                'presence.status.idle.description': 'Inativo: Indica que você está temporariamente indisponível',
                'presence.status.dnd': 'Não perturbe',
                'presence.status.dnd.title': 'Não perturbe - Indica que você prefere não ser interrompido',
                'presence.status.dnd.description': 'Não perturbe: Sinal visível de que você prefere não ser interrompido',
                "presence.status.busy": "Ocupado",
                'presence.status.busy.title': 'Ocupado - Não disponível',
                'presence.status.busy.description': 'Ocupado: Não disponível',
                "presence.status.offline": "Off-line",
                "presence.status.offline.title": "Off-line - Aparecer off-line",
                "presence.status.offline.description": "Off-line: apareça off-line",
                "presence.status.custom": "Personalizado",
                'presence.status.custom.title': 'Personalizado - Estado único com emoji',
                'presence.status.custom.description': 'Personalizado: Estado único com emoji e expiração opcional',
                "dashboard.title": "Painel",
                'dashboard.planUsage': 'Uso do plano',
                'dashboard.filesSummary': 'Meus ficheiros',
                'dashboard.promotions': 'Promoções',
                'dashboard.sessions': 'Sessões ativas',
                "dashboard.explore": "Explorar",
                'dashboard.noSessions': 'Sem sessões ativas',
                'dashboard.welcomeTitle': 'Bem-vindo ao ArChat®',
                'dashboard.welcomeSubtitle': 'Comunique-se em qualquer idioma.',
                'dashboard.stepInvite': 'Passo 1: convide seu primeiro contato',
                'dashboard.stepMessage': 'Passo 2: envie sua primeira mensagem',
                'dashboard.inviteContact': 'Convidar contato',
                'dashboard.exploreArChat': 'Explorar o ArChat',
                'dashboard.promotionsTitle': 'Promoções',
                'dashboard.promotionsText': 'Resumo do programa de indicações e recompensas.',
                'dashboard.viewPromotions': 'Ver promoções',
                'dashboard.usageTitle': 'Uso do plano',
                'dashboard.sessionsTitle': 'Sessões ativas',
                'dashboard.sessionsEmpty': 'Nenhuma sessão ativa',
                'dashboard.filesTitle': 'Meus ficheiros',
                'dashboard.viewFiles': 'Ver meus ficheiros',
                'dashboard.noBlocks': 'Nenhum bloco ativo. Ative pelo menos um em Configurações.',
                'dashboard.openSettings': 'Abrir configurações',
                'dashboard.goToContacts': 'Ir para contatos',
                'dashboard.filesVisible': 'Ficheiros visíveis',
                'dashboard.filesSampleNote': 'Contagem da primeira página (até 500+).',
                'dashboard.loading': 'Carregando dados...',
                'dashboard.error.title': 'Erro',
                'dashboard.error.load': 'Não foi possível carregar os dados de uso',
                'dashboard.error.generic': 'Erro ao carregar o painel',
                'dashboard.error.no_data': 'Não foi possível carregar os dados',
                'dashboard.retry': 'Tentar novamente',
                "dashboard.unlimited": "Ilimitado",
                "dashboard.plan.free": "FREE",
                "dashboard.plan.pro": "PRO",
                "dashboard.plan.enterprise": "ENTERPRISE",
                'dashboard.card.contacts': 'Contatos',
                "dashboard.card.chars": "Personagens",
                'dashboard.card.chars_month': 'Caracteres este mês',
                'dashboard.card.storage': 'Armazenamento',
                'dashboard.card.devices': 'Dispositivos ativos',
                'dashboard.upgrade.title': 'Precisa de mais recursos?',
                'dashboard.upgrade.message': 'Atualize seu plano para obter mais contatos, caracteres, armazenamento e dispositivos ativos.',
                'dashboard.upgrade.button': 'Melhorar Plano',
                'upgrade.title': 'Melhorar Plano',
                'upgrade.close': 'Fechar',
                "upgrade.cancel": "Cancelar",
                'upgrade.activate': 'Ativar Plano PRO',
                'upgrade.activating': 'Ativando...',
                'upgrade.price.note': '',
                'upgrade.comparison.title': 'Comparação de Planos',
                'upgrade.free.label': 'Plano Gratuito',
                'upgrade.free.limits.contacts': '2 contatos máximo',
                'upgrade.free.limits.conversations': '2 conversas máximo',
                'upgrade.free.limits.no_export': 'Sem exportação de dados',
                'upgrade.free.limits.no_advanced': 'Sem recursos avançados',
                'upgrade.pro.label': 'Plano Pro',
                "upgrade.pro.recommended": "RECOMENDADO",
                'upgrade.pro.benefits.contacts': 'Contatos ilimitados',
                'upgrade.pro.benefits.contacts.desc': 'Adicione todos os contatos que precisar sem restrições',
                'upgrade.pro.benefits.conversations': 'Conversas ilimitadas',
                'upgrade.pro.benefits.conversations.desc': 'Mantenha todas as conversas ativas que precisar',
                'upgrade.pro.benefits.export': 'Exportação de conversas',
                'upgrade.pro.benefits.export.desc': 'Exporte suas conversas em múltiplos formatos (PDF, TXT, JSON)',
                'upgrade.pro.benefits.notifications': 'Notificações avançadas',
                'upgrade.pro.benefits.notifications.desc': 'Notificações personalizadas e configuração avançada',
                'upgrade.pro.benefits.translation': 'Tradução automática ilimitada',
                'upgrade.pro.benefits.translation.desc': 'Traduza mensagens sem limites de uso',
                'upgrade.pro.benefits.files': 'Envio de arquivos ilimitado',
                'upgrade.pro.benefits.files.desc': 'Compartilhe arquivos de qualquer tamanho sem restrições',
                "upgrade.pro.benefits.themes": "Temas personalizados",
                'upgrade.pro.benefits.themes.desc': 'Acesso a todos os temas e personalização avançada',
                'upgrade.pro.benefits.security': 'Segurança avançada',
                'upgrade.pro.benefits.security.desc': 'Proteção adicional e recursos de privacidade aprimorados',
                'upgrade.pro.benefits.analytics': 'Estatísticas e análises',
                'upgrade.pro.benefits.analytics.desc': 'Acesse estatísticas detalhadas da sua atividade',
                'upgrade.pro.benefits.priority': 'Suporte prioritário',
                'upgrade.pro.benefits.priority.desc': 'Atenção prioritária e resposta rápida às suas consultas',
                'upgrade.enterprise.label': 'Plano Enterprise',
                'upgrade.enterprise.benefits.contacts': 'Contatos ilimitados',
                'upgrade.enterprise.benefits.support': 'Suporte prioritário 24/7',
                'upgrade.enterprise.benefits.custom': 'Soluções personalizadas',
                'upgrade.enterprise.benefits.advanced': 'Recursos empresariais avançados',
                'upgrade.enterprise.benefits.integration': 'Integrações personalizadas',
                'upgrade.enterprise.benefits.dedicated': 'Suporte dedicado',
                'upgrade.success.title': 'Plano PRO Ativado',
                'upgrade.success.message': 'Seu plano foi atualizado para PRO. Aproveite todos os recursos ilimitados.',
                'upgrade.error.title': 'Erro ao Ativar PRO',
                'upgrade.error.message': 'Não foi possível atualizar o plano. Por favor, tente novamente.',
                'upgrade.error.generic': 'Ocorreu um erro inesperado. Por favor, tente novamente.',
                'upgrade.benefits.contacts': 'Contatos ilimitados',
                'upgrade.benefits.contacts.desc': 'Adicione todos os contatos que precisar sem restrições',
                'upgrade.benefits.conversations': 'Conversas ilimitadas',
                'upgrade.benefits.conversations.desc': 'Mantenha todas as conversas ativas que precisar',
                'upgrade.benefits.export': 'Exportação de conversas',
                'upgrade.benefits.export.desc': 'Exporte suas conversas em múltiplos formatos (PDF, TXT, JSON)',
                'upgrade.benefits.notifications': 'Notificações avançadas',
                'upgrade.benefits.notifications.desc': 'Notificações personalizadas e configuração avançada',
                'upgrade.benefits.translation': 'Tradução automática ilimitada',
                'upgrade.benefits.translation.desc': 'Traduza mensagens sem limites de uso',
                'upgrade.benefits.files': 'Envio de arquivos ilimitado',
                'upgrade.benefits.files.desc': 'Compartilhe arquivos de qualquer tamanho sem restrições',
                "upgrade.benefits.themes": "Temas personalizados",
                'upgrade.benefits.themes.desc': 'Acesso a todos os temas e personalização avançada',
                'upgrade.benefits.security': 'Segurança avançada',
                'upgrade.benefits.security.desc': 'Proteção adicional e recursos de privacidade aprimorados',
                'upgrade.benefits.analytics': 'Estatísticas e análises',
                'upgrade.benefits.analytics.desc': 'Acesse estatísticas detalhadas da sua atividade',
                'upgrade.benefits.priority': 'Suporte prioritário',
                'upgrade.benefits.priority.desc': 'Atenção prioritária e resposta rápida às suas consultas',
                'upgrade.limits.contacts': '2 contatos máximo',
                'upgrade.limits.conversations': '2 conversas máximo',
                'upgrade.limits.no_export': 'Sem exportação de dados',
                'upgrade.limits.no_advanced': 'Sem recursos avançados',
                // API Error Messages
                'api.error.image_processing_not_available': 'O processamento de imagens não está disponível no servidor',
                'api.error.image_functions_not_available': 'Funções de processamento de imagens não disponíveis',
                'api.error.method_not_allowed': 'Método não permitido',
                'api.error.user_not_identified': 'Usuário não identificado',
                'api.error.upload_file_too_large_php': 'O arquivo excede o tamanho máximo permitido pelo PHP',
                'api.error.upload_file_too_large_form': 'O arquivo excede o tamanho máximo permitido pelo formulário',
                'api.error.upload_file_partial': 'O arquivo foi enviado parcialmente',
                'api.error.upload_no_file': 'Nenhum arquivo foi enviado',
                'api.error.upload_no_temp_dir': 'Diretório temporário ausente',
                'api.error.upload_cant_write': 'Erro ao escrever o arquivo no disco',
                'api.error.upload_extension_stopped': 'Uma extensão PHP interrompeu o envio',
                'api.error.upload_generic': 'Erro no envio do arquivo',
                'api.error.file_type_not_allowed': 'Tipo de arquivo não permitido. Apenas imagens são permitidas (JPEG, PNG, GIF, WEBP)',
                'api.error.file_too_large': 'O arquivo é muito grande (máx 10MB)',
                'api.error.storage_limit_exceeded': 'Limite de armazenamento excedido. Atualize seu plano para enviar mais arquivos.',
                'api.error.user_not_found': 'Usuário não encontrado ou inativo',
                'api.error.image_directory_access': 'Erro ao acessar o diretório de imagens',
                'api.error.file_extension_not_allowed': 'Extensão de arquivo não permitida',
                'api.error.temp_file_save': 'Erro ao salvar arquivo temporário',
                'api.error.image_processing': 'Erro ao processar a imagem',
                'api.error.database_update': 'Erro ao atualizar o banco de dados',
                'api.error.internal_server_error': 'Erro interno do servidor',
                'api.error.internal_server_error_debug': 'Erro interno do servidor',
                'api.error.user_id_required': 'ID de usuário obrigatório',
                'api.error.profile_not_found': 'Perfil não encontrado',
                'api.error.profile_load_failed': 'Erro ao carregar o perfil',
                'api.error.invalid_data': 'Dados inválidos',
                'api.error.validation_errors': 'Erros de validação',
                'api.error.profile_update_failed': 'Não foi possível atualizar o perfil',
                'api.error.profile_update_error': 'Erro ao atualizar o perfil',
                // API Success Messages
                'api.success.photo_updated': 'Foto atualizada',
                'api.success.profile_loaded': 'Perfil carregado com sucesso',
                'api.success.profile_updated': 'Perfil atualizado com sucesso',
                // Error Messages - Device Limits
                'errors.deviceLimit.title': 'Limite de dispositivos atingido',
                'errors.deviceLimit.solution': 'Para continuar, saia de outros dispositivos ou melhore seu plano.',
                // Error Messages - Network
                'errors.network.title': 'Erro de conexão',
                'errors.network.message': 'Não foi possível conectar ao servidor. Verifique sua conexão com a internet.',
                // Error Messages - Server
                'errors.server.invalidResponse.title': 'Erro do servidor',
                'errors.server.invalidResponse.message': 'O servidor retornou uma resposta inválida. Tente novamente.',
                // Error Messages - Generic
                'errors.generic.title': 'Erro',
                'errors.generic.message': 'Ocorreu um erro. Tente novamente.',
                'errors.generic.403.title': 'Erro de acesso',
                'errors.generic.403.message': 'Você não tem permissão para realizar esta ação.',
                'errors.saas_max_users': 'Limite de usuários do plano atingido ({current}/{limit}).',
                'errors.tenant_frozen': 'O tenant está temporariamente bloqueado.',
                'errors.auth_invalid_credentials': 'Usuário ou senha incorretos.',
                'errors.unexpected_error': 'Ocorreu um erro inesperado. Tente novamente.',
                'errors.accountInactive.title': 'A conta está inativa. Digite seu e-mail para reativá-la.',
                'errors.accountInactive.activate': 'Ativar agora',
                'errors.accountInactive.accept': 'Aceitar',
                'errors.accountInactive.success': 'Conta reativada. Você já pode entrar.',
                'errors.accountInactive.fail': 'Não foi possível reativar a conta. Tente novamente.',
                'errors.accountInactive.completeSuccess': 'Conta ativada com seu e-mail. Você já pode entrar.',
                'errors.accountInactive.completeFail': 'Não foi possível completar a ativação. Verifique o e-mail e tente de novo.',
                // Plan Errors - Device Limit
                'plan.errors.deviceLimit.title': 'Limite do plano atingido',
                'plan.errors.deviceLimit.message': 'Seu plano atual tem um limite na quantidade de dispositivos conectados simultaneamente.',
                'plan.errors.deviceLimit.solution': 'Para continuar, saia de outros dispositivos ou melhore seu plano para PRO.',
                // Plan Errors - Contacts Limit
                'plan.errors.contactsLimit.title': 'Limite de contatos atingido',
                'plan.errors.contactsLimit.message': 'Seu plano atual tem um limite na quantidade de contatos que você pode ter.',
                'plan.errors.contactsLimit.solution': 'Para adicionar mais contatos, melhore seu plano para PRO.',
                // Plan Errors - Invitations Limit
                'plan.errors.invitationsLimit.title': 'Limite de convites atingido',
                'plan.errors.invitationsLimit.message': 'Seu plano atual tem um limite na quantidade de convites que você pode enviar por dia.',
                'plan.errors.invitationsLimit.solution': 'Para enviar mais convites, melhore seu plano para PRO.',
                // Plan Errors - Messages Limit
                'plan.errors.messagesLimit.title': 'Limite de mensagens atingido',
                'plan.errors.messagesLimit.message': 'Seu plano atual tem um limite na quantidade de mensagens que você pode enviar por dia.',
                'plan.errors.messagesLimit.solution': 'Para enviar mais mensagens, melhore seu plano para PRO.',
                // Plan Errors - Storage Limit
                'plan.errors.storageLimit.title': 'Limite de armazenamento atingido',
                'plan.errors.storageLimit.message': 'Seu plano atual tem um limite na quantidade de armazenamento disponível.',
                'plan.errors.storageLimit.solution': 'Para obter mais armazenamento, melhore seu plano para PRO.',
                // Plan Errors - Upgrade Required
                'plan.errors.upgradeRequired.title': 'Melhoria de plano necessária',
                'plan.errors.upgradeRequired.message': 'Esta função requer um plano superior ao seu atual.',
                'plan.errors.upgradeRequired.solution': 'Melhore seu plano para PRO para acessar esta função.',
                "appearance.theme.system": "Sistema",
                "appearance.theme.corporate": "Corporativo",
                "theme.system": "Sistema",
                "theme.corporate": "Corporativo",
                "founder.title": "FUNDAÇÃO (Fundador)",
                'founder.subtitle': 'Você apoia o projeto desde o início com preço vitalício.',
                'founder.whatIs': 'Os primeiros 150 usuários obtêm o plano FOUNDATION a preço reduzido vitalício.',
                'founder.howItWorks': 'Seu nível Founder depende da sua posição (1 a 150).',
                'founder.benefitsTitle': 'Benefícios',
                'founder.benefitPrice': '$15 / mês (tarifa Founder)',
                'founder.benefitFeatures': 'Inclui todas as funções do plano PRO.',
                'founder.limit': 'Existem apenas 150 vagas Founder.',
                'founder.cancelRule': 'Se cancelar, você perde o status Founder enquanto estiver cancelado.',
                'founder.rejoinRule': 'Se houver vaga novamente, você pode reativar e voltar a ser Founder automaticamente.',
                'founder.tiers.title': 'Níveis Founder',
                "founder.tiers.legendary.name": "Fundador LENDÁRIO",
                'founder.tiers.legendary.range': 'Posição 1–25',
                'founder.tiers.legendary.desc': 'Os primeiros a apoiar o projeto. Máxima prioridade histórica.',
                "founder.tiers.early.name": "PRIMEIRO Fundador",
                'founder.tiers.early.range': 'Posição 26–75',
                'founder.tiers.early.desc': 'Apoio antecipado com reconhecimento especial.',
                "founder.tiers.founder.name": "fundador",
                'founder.tiers.founder.range': 'Posição 76–150',
                'founder.tiers.founder.desc': 'Vaga Founder dentro das 150 vagas.',
                'founder.whatIsLink': 'O que é Founder?',
                'founder.viewTiers': 'Ver níveis Founder',
                'founder.modalClose': 'Fechar',
                'founder.activeCountLabel': 'Founders ativos',
                'founder.urgency.lastSlots': 'Últimas vagas Founder disponíveis',
                "founder.positionLabel": "Fundador #{posição} / {limit}",
                "founder.leaderboard.title": "Principais fundadores",
                "login.email.placeholder": "Ingresa tu email para confirmar tu cuenta",
                "login.email.help": "Um link de confirmação será enviado para seu e-mail",
                "auth.user_not_found": "Usuário não encontrado.",
                "auth.user_inactive": "Sua conta está desativada. Entre em contato com o administrador.",
                "auth.tenant_mismatch": "Sua conta não pertence a este ambiente. Entre em contato com o administrador.",
                "auth.captcha_required": "Você deve completar a verificação de segurança (CAPTCHA).",
                "mail.send_failed": "Não foi possível enviar o e-mail de recuperação. Verifique suas configurações de SMTP ou tente novamente mais tarde.",
                "auth.resend_activation": "Reenviar e-mail de ativação",
                "register.creatingAccount": "Criando sua conta…",
                "common.edit": "Editar",
                "common.on": "Ativado",
                "common.off": "Desabilitado",
                "common.refresh": "Atualizar",
                "system.processing": "Processamento...",
                "captcha.incorrect": "A resposta do captcha está incorreta.",
                "captcha.placeholder": "Escreva a resposta",
                "captcha.questionFormat": "O que é {a} + {b}?",
                'menu.admin': 'Administração',
                "navbar.open_guide": "Guia",
                "invitation.quick_button": "Convidar contato",
                "onboarding.title": "Bem-vindo ao ArChat®",
                "onboarding.subtitle": "Comunique-se com qualquer pessoa em qualquer idioma.",
                "onboarding.step1.label": "Passo 1",
                "onboarding.step1.text": "Convide seu primeiro contato",
                "onboarding.step2.label": "Etapa 2",
                "onboarding.step2.text": "Envie sua primeira mensagem",
                "onboarding.actions.invite": "Convidar contato",
                "onboarding.actions.explore": "Explorar ArChat®",
                'suggestions.sendSuccess': 'Sua sugestão foi enviada com sucesso.',
                'suggestions.sendError': 'Não foi possível enviar a sugestão. Tente novamente.',
                'suggestions.sent': 'Sugestão enviada com sucesso.',
                'errors.suggestionSend': 'Não foi possível enviar a sugestão. Tente novamente.',
                'app.install': 'Instalar o ArChat',
                "menu.open": "Menu",
                "contacts.controls.hide_non_favorites": "Ocultar contatos não favoritos",
                "contacts.controls.show_all": "Mostrar todos os contatos",
                "common.navigation": "Navegação",
                "common.favorite": "Favorito",
                "common.block": "Bloquear",
                "common.user": "Usuário",
                "message.new": "nova mensagem",
                "message.edit": "Editar mensagem",
                "message.edit.save": "Salvar edição",
                "message.edit.cancel": "Cancelar edição",
                'message.translating': 'A traduzir...',
                'message.translation_failed': 'Não foi possível traduzir',
                "message.not_translated": "Texto original",
                'message.retry_send': 'Tentar novamente',
                'message.retrying': 'A tentar novamente...',
                "message.delete": "Excluir mensagem",
                'message.deleted_placeholder': 'Mensagem eliminada',
                "message.edited": "Editado",
                "message.edited_at": "Editado em",
                'message.delete_for_me.tooltip': 'Excluir para mim',
                'message.delete_for_me.aria': 'Excluir esta mensagem apenas para mim',
                'message.delete_for_me.confirm_title': 'Excluir mensagem',
                'message.delete_for_me.confirm_message': 'Esta mensagem será excluída apenas da sua visualização.',
                'message.delete_for_everyone.tooltip': 'Excluir para todos',
                'message.delete_for_everyone.aria': 'Excluir esta mensagem para todos os participantes',
                'message.delete_for_everyone.confirm_title': 'Excluir mensagem para todos',
                'message.delete_for_everyone.confirm_message': 'Esta mensagem será excluída para você e para o outro participante.',
                'message.delete_for_everyone.window_expired': 'Janela de exclusão expirada',
                "message.translation.show": "Veja original e tradução",
                "message.translation.hide": "Ocultar tradução",
                "emoji.search": "Pesquisar emoticons",
                "emoji.close": "Fechar seletor",
                "captcha.refresh": "Regenerar CAPTCHA",
                'presence.unavailable': 'Status indisponiveis',
                'presence.maintenance': 'Servidor em manutencao',
                "home.access_nav": "Acesso ao aplicativo",
                "common.requiredFields": "Preencha todos os campos obrigatórios.",
                "bio.view": "Ver biografia",
                "profile.invitations.title": "Convites",
                "profile.invitations.validated": "Convites validados",
                "profile.invitations.nextBadge": "Próxima conquista",
                "profile.invitations.progress": "Progresso",
                "profile.invitations.achievement": "Conquista",
                "profile.invitations.topInviterAchieved": "Número máximo de convidados atingido",
                "profile.invitations.badges.networkBuilder": "Construtor de rede",
                "profile.invitations.badges.topInviter": "Convidador Máximo",
                "profile.invitations.achievement.networkBuilderMessage": "Você convidou 20 usuários no ArChat.",
                "profile.invitations.achievement.topInviterMessage": "Você convidou 50 usuários no ArChat.",
                "profile.manage_plan": "Gerenciar plano",
                "plan.current_plan": "Plano atual",
                "plan.current": "Actual",
                'plan.footer_prefix': 'Plano:',
                "plan.upgrade_to_pro": "Atualize para PRO",
                "plan.upgrade_to_foundation": "Atualize para a FUNDAÇÃO",
                "plan.payment_coming": "O pagamento com Paddle estará disponível em breve. Você pode alterar os planos aqui.",
                "plan.payment_coming_title": "Breve",
                "plan.foundation_full": "A cota da FUNDAÇÃO está completa (150 fundadores). Você pode escolher PRO.",
                "plan.sold_out": "Esgotado",
                "plan.founder_spots_remaining": "Apenas {count} vagas disponíveis",
                "plan.founders_occupied": "fundadores ocupados",
                "plan.upgrade_not_allowed": "Somente usuários com plano GRATUITO podem solicitar um upgrade.",
                "plan.free_contacts": "Hasta 2 contactos",
                "plan.free_no_files": "Sin archivos",
                "plan.free_retention": "Historial 30 días",
                "plan.pro_files": "Archivos hasta 50MB",
                "plan.pro_export": "Exportación",
                "plan.founder_support": "Prioridad soporte",
                "plan.founder_badge": "Badge fundador",
                "billing.usage.contacts": "Contatos",
                "billing.usage.chars_month": "Caracteres por mês",
                "billing.usage.storage": "Armazenamento usado",
                "billing.usage.devices": "Dispositivos conectados",
                "billing.loading": "Carregando...",
                'billing.subscription.section_title': 'Assinatura e faturamento',
                'billing.subscription.provider_note': 'Provedor',
                'billing.subscription.paddle_active': 'Paddle (plano ativo no app)',
                'billing.subscription.mp_action_ok': 'Solicitação registrada. Se o checkout não abriu, verifique sua conexão ou tente novamente.',
                'billing.paddle.manage_subscription_button': 'Gerenciar assinatura',
                'billing.paddle.portal_confirm_title': 'Portal de faturamento',
                'billing.paddle.portal_confirm': 'O portal seguro da Paddle abrirá para atualizar forma de pagamento, faturas ou cancelar a assinatura. Continuar?',
                'billing.paddle.portal_opened_hint': 'O portal Paddle abriu em uma nova aba. Atualize seu perfil se o plano não foi atualizado.',
                'billing.paddle.portal_error': 'Não foi possível abrir o portal Paddle. Tente novamente mais tarde ou entre em contato com o suporte.',
                'billing.paddle.no_link_error': 'Ainda não há vínculo de assinatura Paddle na sua conta. Se acabou de pagar, aguarde o webhook ou entre em contato com o suporte.',
                'billing.paddle.api_not_configured': 'O servidor não tem a configuração da API Paddle (PADDLE_API_KEY). Um administrador deve configurá-la.',
                "billing.descriptions.contacts": "Total de contatos armazenados em sua conta",
                "billing.descriptions.storage": "Armazenamento usado para arquivos e mídia",
                "billing.descriptions.chars_month": "Personagens traduzidos este mês",
                "billing.descriptions.devices": "Dispositivos conectados ativos",
                'billing.paddle.return_title': 'Pagamento recebido',
                'billing.paddle.return_body': 'Se você concluiu o checkout, seu plano será atualizado em breve após a confirmação da Paddle. Você pode voltar ao início.',
                'billing.paddle.verifying': 'Verificando seu plano…',
                'billing.paddle.not_logged_in': 'Entre para ver o status atualizado do seu plano.',
                'billing.paddle.plan_updated': 'Plano atualizado com sucesso: {plan}',
                'billing.paddle.plan_current': 'Seu plano atual: {plan}',
                'billing.paddle.plan_current_founder': 'Agora você é Founder — {plan}',
                'billing.paddle.still_free_hint': 'Se ainda aparecer FREE após alguns segundos, o webhook pode estar atrasado. Verifique os logs do backend ou atualize esta página.',
                'billing.paddle.pro_extra_hint': 'Você pode voltar ao início para usar seu plano.',
                "avatar.errors.too_large": "A imagem é muito grande. Tamanho máximo: 2 MB.",
                "avatar.preview.title": "Visualização do avatar",
                "profile.avatar.error_title": "Não foi possível atualizar o avatar",
                "profile.avatar.error.title": "Não foi possível atualizar o avatar",
                "profile.avatar.error.size": "A imagem excede o tamanho permitido. O máximo é 2 MB.",
                "profile.avatar.tooLarge.title": "Imagem muito grande",
                "profile.avatar.tooLarge.message": "A foto excede o tamanho permitido. O máximo é 2 MB.",
                "profile.avatar.uploadError.title": "Não foi possível atualizar o avatar",
                "profile.avatar.uploadError.message": "Ocorreu um problema ao carregar a imagem. Tente novamente.",
                "profile.saveSuccess.title": "Perfil atualizado",
                "profile.saveSuccess.message": "Suas alterações foram salvas com sucesso.",
                "profile.avatar.file_too_large": "A imagem excede o tamanho máximo permitido (2 MB).",
                "profile.avatar.file_too_large_hint": "Escolha uma imagem mais clara ou reduza o tamanho e tente novamente.",
                "profile.photo.camera.front": "câmera frontal",
                "profile.photo.camera.back": "câmera traseira",
                "profile.photo.camera.web": "Webcam",
                "profile.photo.close": "Fechar",
                "block.toggle_error": "Não foi possível bloquear ou desbloquear.",
                "contact.favorite.add": "Adicionar aos favoritos",
                "contact.favorite.remove": "Remover dos favoritos",
                "contact.block.block": "Bloquear",
                "contact.block.unblock": "Desbloquear",
                "conversation.notFound": "Conversa não encontrada",
                "help.how.step1.description": "Use seu apelido e senha para acessar. Se você não tiver uma conta, ela será criada automaticamente.",
                "help.how.step2.title": "Convide seu contato",
                "help.how.step2.description": "Convide por e-mail do seu perfil e defina o idioma e modo de conversa.",
                "help.how.step3.title": "Escreva no seu idioma",
                "help.how.step3.description": "Escreva no seu idioma preferido e o ArChat® traduz automaticamente a mensagem.",
                "help.how.step4.title": "O receptor recebe traduzido",
                "help.how.step4.description": "A outra pessoa recebe a mensagem traduzida para o seu idioma com contexto e clareza.",
                "help.message_time_context.title": "Contexto temporal das mensagens",
                "help.message_time_context.description": "Cada mensagem pode salvar a hora local, o fuso horário e o país do remetente no momento do envio. Desta forma você pode ver para onde e a que horas o outro usuário enviou.",
                "help.message_time_context.point1": "No plano GRATUITO, apenas a hora do seu fuso horário (receptor) é mostrada.",
                "help.message_time_context.point2": "No plano PRO também são mostrados a hora local, o país e o fuso horário do emissor.",
                "help.message_time_context.point3": "O contexto é salvo historicamente em cada mensagem.",
                "help.message_time_context.point4": "Recursos avançados de auditoria estão disponíveis em planos superiores.",
                'presence.custom.title': 'Status personalizado',
                'presence.custom.status': 'Status personalizado',
                'presence.custom.placeholder': 'Ex.: Tomando um cafe ☕',
                "presence.custom.emoji": "Emoji (opcional)",
                'presence.custom.emojiHelp': 'Selecione um emoji ou digite um',
                'presence.custom.temporary': 'Status temporario (expira automaticamente)',
                'presence.custom.expiration': 'Data de expiracao',
                'presence.custom.expirationHelp': 'O status voltara para "Online" quando expirar',
                'presence.custom.suggestions': 'Sugestoes',
                'presence.custom.preview': 'Pre-visualizacao',
                'presence.custom.save': 'Salvar status',
                'presence.custom.required': 'O status personalizado e obrigatorio',
                'presence.custom.maxLength': 'Maximo de 64 caracteres',
                'presence.custom.expirationRequired': 'Voce deve selecionar uma data de expiracao',
                'presence.custom.expirationFuture': 'A data de expiracao deve ser futura',
                'presence.custom.selectEmoji': 'Selecionar emoji',
                "invitation.success.title": "Convite enviado",
                "invitation.success.message": "Convite enviado com sucesso.\\n\\nO contato receberá um e-mail com um link para aceitar o convite. Uma vez aceito, você pode começar a conversar com ele.",
                "invitation.top.title": "Principais construtores de rede",
                "invitation.top.invitesSuffix": "convites",
                "invitation.ranking.position": "Posição",
                "invitation.ranking.user": "Usuário",
                "invitation.ranking.validatedInvites": "Convites validados",
                "invitation.ranking.empty": "Não há convites validados para exibição.",
                "invitation.ranking.loading": "Carregando classificação...",
                "invitation.ranking.loadError": "A classificação não pôde ser carregada.",
                "invitations.waitBeforeResend": "Você ainda não pode reenviar o convite. Você deve esperar 10 minutos entre cada envio para evitar enviar spam ao usuário convidado.",
                "invitations.captchaQuestion": "Quanto é %1 + %2?",
                "invitations.resendSuccess": "O convite foi encaminhado com sucesso.",
                "invitations.dailyLimit": "Você atingiu o máximo permitido de reenvios hoje.",
                "invitations.invalidEmail": "O servidor de e-mail informou que este endereço é inválido.",
                "achievement.unlocked": "Conquista desbloqueada",
                "achievement.continue": "Continuar",
                'dashboard.not_available': 'Não disponível',
                "plan.errors.chatsLimit.title": "Limite de conversas atingido",
                "plan.errors.chatsLimit.message": "Seu plano atual tem um limite no número de conversas que você pode ter.",
                "plan.errors.chatsLimit.solution": "Para criar mais conversas, atualize seu plano para PRO.",
                "errors.generic": "Ocorreu um erro inesperado. Tente novamente.",
                "errors.modal.title": "Erro",
                "errors.modal.copyDetails": "Copiar detalhe",
                "errors.modal.close": "Fechar",
                "errors.modal.reportSupport": "Reportar ao suporte",
                "errors.avatarTooLarge": "A imagem excede o tamanho permitido de 2 MB.",
                "errors.avatarTooLarge.title": "Imagem muito grande",
                "errors.avatarTooLarge.message": "A imagem excede o tamanho permitido de 2 MB.",
                "errors.invalidImageType": "O arquivo selecionado não é uma imagem válida.",
                "errors.invalidImageType.title": "Arquivo inválido",
                "errors.invalidImageType.message": "O arquivo selecionado não é uma imagem válida.",
                "errors.uploadFailed": "Não foi possível fazer upload da imagem. Tente novamente.",
                "errors.uploadFailed.title": "Erro ao fazer upload",
                "errors.uploadFailed.message": "Não foi possível fazer upload da imagem. Tente novamente.",
                "errors.conversationCreate": "Erro ao criar conversa. Por favor, tente novamente.",
                "errors.conversationInvalidId": "ID de conversa inválido.",
                "errors.conversationOpen": "Erro ao abrir conversa. Por favor, tente novamente.",
                "errors.favoriteUpdate": "Falha ao atualizar favorito",
                "errors.blockUpdate": "Não foi possível atualizar o bloqueio",
                "errors.messageEdit": "Erro ao editar a mensagem.",
                "errors.foundation_sold_out": "As vagas para fundadores estão esgotadas.",
                "errors.userInactive.title": "Conta desativada",
                "errors.tenantMismatch.title": "Erro do inquilino",
                'auth.tagline': 'O poder de ser compreendido, independentemente do idioma',
                'auth.sign_in': 'Entrar',
                'auth.create_account': 'Criar conta',
                'ui.search_contact': 'Buscar contato...',
                "ui.language": "Linguagem",
                'profile.my_profile': 'Meu Perfil',
                "profile.status": "Estado",
                'profile.invite_email': 'Convidar Contato por Email',
                'profile.sent_invitations': 'Convites Enviados',
                'profile.users': 'Usuários',
                'profile.settings': 'Configurações',
                'profile.appearance': 'Aparência',
                'profile.logout': 'Sair',
                "contacts.mode": "Modo",
                'contacts.sent': 'Enviado',
                'contacts.actions': 'Ações',
                'contacts.pending': 'Pendente',
                'contacts.available': 'Disponível',
                'contacts.invited_registered': 'Convidado - Registrado',
                "table.email": "E-mail",
                "table.language": "Linguagem",
                "table.mode": "Modo",
                "table.status": "Estado",
                'table.sent': 'Enviado',
                'table.actions': 'Ações',
  'promotions.invite.message': 'Eu te convido para o ArChat — fale em qualquer idioma. Nos dois ganhamos beneficios.',
  'promotions.progress.pending': 'Voce tem convites pendentes para desbloquear recompensas.',
  'promotions.progress.in_progress': 'Seus convites estao em andamento: as recompensas ativam apos uma conversa real.',
  'promotions.progress.remaining': 'Falta(m) {count} conversa(s) para voce receber sua recompensa.',
                "promotions.progress.sent_count": "Enviado",
  'promotions.progress.pending_count': 'Pendentes',
  'promotions.progress.in_progress_count': 'Em andamento',
  'promotions.progress.completed_count': 'Concluidos',
  'promotions.banner.empty': 'Comece agora: convide contatos e desbloqueie beneficios.',
  'promotions.banner.pending': 'Voce tem convites pendentes: conclua uma conversa real e ganhe recompensas.',
  'promotions.banner.reward': 'Voce ja desbloqueou recompensas! Continue convidando para aumentar seus ganhos.',
  'promotions.cta.copy': 'Copiar mensagem e link',
  'promotions.cta.copied': 'Mensagem copiada',
  'promotions.cta.copy_error': 'Nao foi possivel copiar a mensagem',

  'promotions.title': 'Promocoes e recompensas',
  'promotions.subtitle': 'Convide contatos e desbloqueie beneficios com uso real.',
  'promotions.how_it_works': 'Como funciona',
  'promotions.step1': 'Convide um contato pelo seu perfil.',
  'promotions.step2': 'Quando a pessoa aceitar e conversar com interacao real, a validacao acontece automaticamente.',
  'promotions.step3': 'A recompensa e creditada e seu progresso e atualizado.',
                "promotions.rewards.title": "Recompensas",
  'promotions.reward.invite': 'Recompensa para cada indicacao validada.',
  'promotions.reward.milestone': 'Bonus por marcos de crescimento.',
  'promotions.reward.ranking': 'Visibilidade no ranking dos principais construtores de rede.',
  'promotions.progress.title': 'Seu progresso',
                "promotions.progress.sent": "Enviado",
  'promotions.cta.invite': 'Convidar contato',
  'promotions.banner': 'Ative promocoes: convide e ganhe recompensas por uso real.',
  'promotions.modal.title': 'Programa de promocoes',
  'promotions.modal.body': 'Ganhe +10.000 caracteres por convite validado.\\\\nConvide hoje e desbloqueie recompensas.',
  'promotions.modal.cta': 'Ver promocoes',
                "app.install_ios_hint": "Para instalar: Compartilhar > Adicionar à tela inicial",
                'menu.promotions': 'Promoções',
                "suggestions.new": "Nova sugestão",
                "suggestions.empty": "Você ainda não enviou sugestões.",
                "suggestions.admin_note": "Nota da equipe",
                "suggestions.status.pending": "Brinco",
                "suggestions.status.reviewed": "Revisado",
                "suggestions.status.planned": "Planejado",
                "suggestions.status.implemented": "Implementado",
                "suggestions.status.rejected": "Rejeitado",
                "referral.promo": "Convide e ganhe 10.000 personagens",
                "referral.stats.sent": "Enviado",
                "referral.stats.accepted": "Aceito",
                "referral.stats.rewards": "Recompensas",
                "referral.reward.pending": "Brinco",
                "referral.reward.granted": "Preenchido",
                "referral.reward.invalid": "Inválido",
                "referral.reward.in_progress": "Em uso",
                "referral.limit.reached": "Limite de recompensa atingido",
                "referral.waiting.usage": "+10.000 caracteres cada quando você e seu convidado enviam pelo menos uma mensagem de texto real no mesmo chat (validado pelo servidor).",
                "common.avatar": "avatar",
                "plan.free_characters_month": "30,000 characters / month",
                "plan.pro_characters_month": "300,000 characters / month",
                "messages.empty": "Ainda não há mensagens",
                "messages.loading": "Carregando mensagens...",
                "messages.connecting_server": "Conectando ao servidor de mensagens...",
                "messages.pending_send_count": "{count} mensagem(s) aguardando entrega",
                "presence.custom.suggestion.coffee": "Tendo alguns amigos ☕",
                "presence.custom.suggestion.soccer": "Na quadra ⚽",
                "presence.custom.suggestion.working": "Trabalhando como um louco 💪",
                "presence.custom.suggestion.lunch": "Almoçando 🍽️",
                "presence.custom.suggestion.family": "Almoço em família 👨‍👩‍👧‍👦",
                "presence.custom.suggestion.studying": "Estudando 📚",
                "presence.custom.suggestion.travel": "Em uma viagem ✈️",
                "presence.custom.suggestion.meeting": "Em reunião 💼",
                "presence.custom.suggestion.resting": "Descansando 😴",
                "presence.custom.suggestion.gaming": "Jogando videogame 🎮",
                "presence.custom.suggestion.reading": "Lendo 📖",
                "presence.custom.suggestion.offlineSoon": "Já volto ⏳",
                "invitation.safe.phase_notice": "Fase ativa segura: benefícios pendentes de ativação comercial (sem impacto real nos limites).",
                "invitation.safe.generate_code": "Gerar link/código",
                "invitation.safe.refresh_top3": "Atualizar os 3 principais",
                "invitation.safe.top_loading": "Carregando principais convidadores...",
                "invitation.safe.top_empty": "Ainda não há convidados em destaque.",
                "invitation.safe.hide_full_ranking": "Ocultar classificação completa",
                "invitation.safe.view_full_ranking": "Veja a classificação completa",
                "invitation.safe.hide_metrics_dashboard": "Ocultar painel de métricas",
                "invitation.safe.view_metrics_dashboard": "Ver painel de métricas",
                "invitation.safe.prepared_link": "Link preparado",
                "invitation.safe.email_placeholder": "email@dominio.com",
                "invitation.safe.register_pending": "Registrar convite pendente",
                "invitation.safe.status_summary": "Resumo do status",
                "invitation.safe.summary.pending": "Brincos",
                "invitation.safe.summary.registered": "Registrado",
                "invitation.safe.summary.active": "Ativo",
                "invitation.safe.summary.validated": "Validado",
                "invitation.safe.summary.rejected": "Rejeitado",
                "invitation.safe.sent_invitations": "Convites emitidos",
                "invitation.safe.table.id": "EU IA",
                "invitation.safe.table.invited_email": "E-mail do convidado",
                "invitation.safe.table.code": "Código",
                "invitation.safe.table.status": "Estado",
                "invitation.safe.table.created": "Criado",
                "invitation.safe.empty_sent": "Nenhum convite emitido ainda.",
                "invitation.safe.simulated_rewards": "Recompensas simuladas ganhas",
                "invitation.safe.empty_rewards": "Nenhuma recompensa simulada por enquanto.",
                "invitation.safe.error.load_status": "Não foi possível carregar o status do convite.",
                "invitation.safe.error.generate_code": "O código não pôde ser gerado.",
                "invitation.safe.error.invalid_email": "Digite um e-mail válido para registrar o convite.",
                "invitation.safe.error.register_pending": "O convite pendente não pôde ser registrado.",
                "invitation.safe.success.code_generated": "Código gerado com sucesso.",
                "invitation.safe.success.pending_registered": "Convite pendente registrado em modo de segurança.",
                "invitation.status.deleted": "Eliminado",
                "invitation.deleted.tooltip": "Este convite foi removido",
                "invitation.status.rejected": "Rejeitado",
                "invitation.status.bounced": "Devolvido",
                "invitation.status.unknown": "Estado desconhecido",
                "dashboard.admin.title": "Métricas de crescimento",
                "dashboard.admin.newUsersToday": "Novos usuários hoje",
                "dashboard.admin.messagesSentToday": "Mensagens enviadas hoje",
                "dashboard.admin.translationsUsed": "Traduções usadas",
                "dashboard.admin.invitesCreated": "Convites criados",
                "dashboard.admin.invitesValidated": "Convites validados",
                "dashboard.admin.inviteConversion": "Conversão de convite",
                "dashboard.admin.kFactor": "Fator K",
                "dashboard.admin.newUsers": "Novos usuários",
                "dashboard.admin.messagesSent": "Mensagens enviadas",
                "dashboard.admin.noData": "Sem dados",
                "dashboard.admin.kFactor.viral": "Viral",
                "dashboard.admin.kFactor.stable": "Estável",
                "dashboard.admin.kFactor.low": "Baixo",
                "dashboard.admin.emailMetrics": "Métricas de e-mail",
                "dashboard.admin.email.sent": "Enviado",
                "dashboard.admin.email.delivered": "Entregue",
                "dashboard.admin.email.opened": "abrir",
                "dashboard.admin.email.clicked": "Cliques",
                "dashboard.admin.email.bounced": "Devolvido",
                "dashboard.admin.email.deliveryRate": "Taxa de entrega",
                "dashboard.admin.email.openRate": "Taxa de abertura",
                "dashboard.admin.email.bounceRate": "taxa de rejeição",
                "dashboard.admin.funnelMetrics": "Métricas de funil",
                "dashboard.admin.funnel.registered": "Registrado",
                "dashboard.admin.funnel.confirmed": "Confirmado",
                "dashboard.admin.funnel.loggedIn": "Primeiro login",
                "dashboard.admin.funnel.firstMessage": "Primeira mensagem",
                "dashboard.admin.funnel.abandoned": "Abandonado",
                "dashboard.admin.funnel.conversionRate": "Taxa de conversão",
                "dashboard.admin.funnel.activationRate": "Taxa de ativação",
                "dashboard.admin.funnel.dropoffRate": "Taxa de abandono",
                "dashboard.admin.loading": "Carregando métricas...",
                "dashboard.admin.errorLoad": "O painel de métricas não pôde ser carregado.",
                "dashboard.admin.growthViral": "Crescimento viral",
                "dashboard.admin.growthStable": "Crescimento estável",
                "dashboard.admin.growthLow": "Baixo crescimento",
                'upgrade.price.amount': '',
                'upgrade.price.period': '',
                "upgrade.enterprise.title": "ENTERPRISE",
                "errors.modal.code": "Código",
                "errors.modal.message": "Mensagem",
                "errors.modal.path": "Rota",
                "errors.modal.time": "Hora",
                "errors.modal.timestamp": "Carimbo de data e hora",
                "errors.modal.copied": "Detalhe copiado",
                "errors.network": "Não foi possível conectar-se ao servidor. Verifique sua conexão.",
                "errors.unexpected": "Ocorreu um erro inesperado. Tente novamente.",
                "errors.boundary.title": "ERRO DE REAÇÃO CAPTURADO",
                "errors.boundary.request_id": "ID da solicitação X:",
                "errors.boundary.correlate": "Mapear para backend/logs/structured.log",
                "errors.boundary.message_label": "Mensagem:",
                "errors.boundary.stack_trace": "Rastreamento de pilha",
                "errors.boundary.component_stack": "pilha de componentes",
                "errors.boundary.empty": "(vazio)",
                "errors.boundary.reload_page": "Recarregar página",
                "errors.ui_boundary.refresh": "Erro na interface do ArChat – recarregamento da página",
                "bootstrap.error.title": "ArChat® — Erro de inicialização",
                "common.reload": "Recarregar",
                "admin.access_denied.message": "Mensagem",
                "admin.access_denied.title": "Título",
                "admin.action.change_plan": "Alterar plano",
                "admin.action.reactivate": "Reativar",
                "admin.action.suspend": "Suspender",
                "admin.action.view": "Visualizar",
                "admin.confirm.change_plan.message": "Mensagem",
                "admin.confirm.change_plan.title": "Título",
                "admin.confirm.suspend.message": "Mensagem",
                "admin.confirm.suspend.title": "Título",
                "admin.details.created": "Criado",
                "admin.details.current_plan": "Plano atual",
                "admin.details.domain": "Domínio",
                "admin.details.last_activity": "Última atividade",
                "admin.details.name": "Inhame",
                "admin.details.plan": "Plano",
                "admin.details.status": "Status",
                "admin.details.subscription": "Subscrição",
                "admin.details.tenant_id": "ID do locatário",
                "admin.details.tenant_info": "Informações do inquilino",
                "admin.details.usage": "Uso",
                "admin.error.change_plan": "Alterar plano",
                "admin.error.generic": "Genérico",
                "admin.error.load_details": "Carregar detalhes",
                "admin.error.load_tenants": "Carregar inquilinos",
                "admin.error.reactivate": "Reativar",
                "admin.error.suspend": "Suspender",
                "admin.error.title": "Título",
                "admin.filter.active": "Ativar",
                "admin.filter.all_plans": "Todos os planos",
                "admin.filter.all_status": "Todos os status",
                "admin.filter.suspended": "Suspender",
                "admin.limit.devices": "Dispositivos",
                "admin.limit.invitations": "Convites",
                "admin.limit.messages": "mensagens",
                "admin.limit.storage": "Armazenar",
                "admin.limit.users": "Usuários",
                "admin.loading": "Carregando",
                "admin.no_tenants": "Não inquilinos",
                "admin.plan.enterprise": "Enterprise",
                "admin.plan.free": "Free",
                "admin.plan.pro": "Pro",
                "admin.status.active": "Ativar",
                "admin.status.suspended": "Suspender",
                'admin.subscription.id': 'Id',
                "admin.subscription.last_payment": "Último pagamento",
                "admin.subscription.status": "Status",
                "admin.subtitle": "Legenda",
                "admin.success.plan_changed": "Plano alterado",
                "admin.success.tenant_reactivated": "Inquilino reativado",
                "admin.success.tenant_suspended": "Inquilino suspenso",
                "admin.success.title": "Título",
                "admin.table.actions": "Ações",
                "admin.table.messages": "mensagens",
                "admin.table.name": "Inhame",
                "admin.table.plan": "Plano",
                "admin.table.status": "Status",
                "admin.table.storage": "Armazenar",
                "admin.table.tenant_id": "ID do locatário",
                "admin.table.users": "Usuários",
                "admin.title": "Título",
                "admin.usage.devices": "Dispositivos",
                "admin.usage.invitations": "Convites",
                "admin.usage.messages": "mensagens",
                "admin.usage.storage": "Armazenar",
                "admin.usage.users": "Usuários",
                "auth.login": "Conecte-se",
                "auth.register": "Cadastre-se",
                "auth.reset_password": "redefinir senha",
                "billing.cancel.button": "botão",
                "billing.cancel.canceling": "Cancelando",
                "billing.cancel.confirm": "Confirmar",
                "billing.cancel.error": "Erro",
                "billing.cancel.success": "sucesso",
                "billing.character_billing.characters_used": "Caracteres usados",
                "billing.character_billing.consumption_pct": "% de consumo",
                "billing.character_billing.days_remaining": "Dias restantes",
                "billing.character_billing.deletion_date": "Data de exclusão",
                "billing.character_billing.period_start": "Início do período",
                "billing.character_billing.renewal_date": "Data de renovação",
                "billing.character_billing.title": "Título",
                "billing.current_plan": "Plano atual",
                "billing.founder_badge": "Distintivo de fundador",
                "billing.no_plans": "Não planeje",
                'billing.subscription.canceled': 'Canceled',
                'billing.subscription.canceled_note': 'Canceled note',
                "billing.subscription.next_payment": "Próximo pagamento",
                "billing.subscription.plan": "Plano",
                'billing.subscription.price': 'Preço do plano',
                "billing.subscription.started": "Iniciado",
                "billing.subscription.status": "Status",
                "billing.subscription.mp_flow.subscribe_failed": "A assinatura não pôde ser iniciada. Tente novamente.",
                "billing.subscription.mp_flow.change_plan_failed": "O plano não poderia ser alterado. Tente novamente.",
                "billing.subscription.mp_status.pending": "Brinco",
                "billing.subscription.mp_status.authorized": "Autorizado",
                "billing.subscription.mp_status.active": "Ativo",
                "billing.subscription.mp_status.paused": "Pausado",
                "billing.subscription.mp_status.cancelled": "Cancelado",
                "billing.subscription.mp_status.inactive": "Inativo",
                "billing.subscription.mp_status.unknown": "Um estranho",
                "billing.unlimited": "Ilimitado",
                "billing.update_plan": "Plano de atualização",
                "billing.update_plan_modal.title": "Título",
                "billing.usage.loading": "Carregando",
                "common.accept": "Aceitar",
                "common.confirmPassword": "Confirme sua senha",
                "common.continue": "Continuar",
                "common.error": "Erro",
                "dashboard.upgrade.to_plan": "Planejar",
                "emoji.noResults": "Sem resultados",
                "emoji.pick": "Escolha",
                "export.restricted.message": "Mensagem",
                "export.restricted.title": "Título",
                "export.restricted.upgrade": "Atualizar",
                "founder.*": "*",
                "help.faq.a1": "A1",
                "help.faq.a2": "A2",
                "help.faq.a3": "A3",
                "help.faq.a4": "A4",
                "help.faq.a5": "A5",
                "help.faq.a6": "A6",
                "help.faq.a7": "A7",
                "help.faq.q1": "1º trimestre",
                "help.faq.q2": "2º trimestre",
                "help.faq.q3": "3º trimestre",
                "help.faq.q4": "4º trimestre",
                "help.faq.q5": "Q5",
                "help.faq.q6": "Q6",
                "help.faq.q7": "Q7",
                "help.faq.title": "Título",
                "help.howWorks.step4.point7": "Ponto 7",
                "help.message_time_context.free_vs_pro": "Grátis vs profissional",
                "help.message_time_context.point5": "Ponto 5",
                "help.plans.enterprise.benefits": "Benefícios",
                "help.plans.enterprise.description": "Descrição",
                "help.plans.enterprise.title": "Título",
                "help.plans.foundation.devices": "Dispositivos",
                "help.plans.free.description": "Descrição",
                "help.plans.free.devices": "Dispositivos",
                "help.plans.free.limits": "Limites",
                "help.plans.free.title": "Título",
                "help.plans.intro": "Introdução",
                "help.plans.pro.benefits": "Benefícios",
                "help.plans.pro.description": "Descrição",
                "help.plans.pro.devices": "Dispositivos",
                'help.plans.pro.price': '$19 / mês',
                "help.plans.pro.title": "Título",
                "help.plans.pro.upgrade": "Atualizar",
                "help.plans.title": "Título",
                "help.plans.urgent_slots_badge": "Selo de slots urgentes",
                "help.slogan.final": "Fim",
                "help.suggestions.point1": "Ponto1",
                "help.suggestions.point2": "Ponto2",
                "help.suggestions.title": "Título",
                "invitation.already_contact_added": "Contato já adicionado",
                "invitation.already_contact_title": "Já entre em contato com o título",
                "invitation.already_pending": "Já pendente",
                "invitation.language.invalid": "Inválido",
                "message.send": "Enviar",
                "message.sendFile": "Enviar arquivo",
                "messages.conversations": "Conversas",
                "messages.no_conversations_subtitle": "Sem legenda de conversas",
                "messages.no_conversations_title": "Sem título de conversas",
                "presence.custom.edit": "Editar",
                "profile.enrichment.country": "país",
                "profile.enrichment.country.select": "Selecione",
                "profile.enrichment.description": "Descrição",
                "profile.enrichment.org_size": "Tamanho da organização",
                "profile.enrichment.org_size.placeholder": "marcador de lugar",
                "profile.enrichment.save": "Salvar",
                "profile.enrichment.skip": "pular",
                "profile.enrichment.title": "Título",
                "profile.enrichment.usage_type.label": "Rótulo",
                "profile.enrichment.usage_type.placeholder": "marcador de lugar",
                "profile.founderPosition": "Posição de Fundador",
                "settings.confirmations.description": "Descrição",
                "settings.confirmations.disable": "Desativar",
                "settings.confirmations.title": "Título",
                "settings.confirmations.updated": "Atualizado",
                "settings.title": "Título",
                "theme.description": "Descrição",
                "google.unavailable_tenant": "O Google não está disponível para este locatário.",
                "google.unavailable": "Google indisponível.",
                "google.verify_client_id": "Verifique o ID do cliente no Console do Google Cloud.",
                'google.login_aria': 'Entrar com o Google',
                "message.preview_alt": "Visualização",
                "message.image_attachment_alt": "Imagem anexada",
                "profile.avatar.alt": "avatar",
                "plan.name.free": "FREE",
                "plan.name.pro": "PRO",
                "plan.name.foundation": "FOUNDATION",
                "plan.name.enterprise": "ENTERPRISE",
                "register.emailPlaceholder": "you@email.com",
                "invitation.top.loading": "Carregando principais convidadores...",
                "invitation.top.empty": "Nenhum convidado em destaque ainda.",
                "invitation.contacts.title": "Convidar contatos",
                "invitation.contacts.safe_phase_note": "Fase segura ativa: benefícios pendentes sem impacto nos limites reais.",
                "invitation.contacts.generate_code": "Gerar código/link",
                "invitation.contacts.refresh_top3": "Atualizar os 3 principais",
                "invitation.contacts.hide_full_ranking": "Ocultar classificação completa",
                "invitation.contacts.show_full_ranking": "Mostrar classificação completa",
                "invitation.contacts.hide_metrics_dashboard": "Ocultar painel de métricas",
                "invitation.contacts.show_metrics_dashboard": "Mostrar painel de métricas",
                "invitation.contacts.prepared_link_label": "Link preparado:",
                "invitation.contacts.email_placeholder": "e-mail@domínio.com",
                "invitation.contacts.register_pending": "Registrar convite pendente",
                "invitation.contacts.status_summary": "Resumo do status",
                "invitation.contacts.sent_invitations": "Convites enviados",
                "invitation.contacts.invited_email": "E-mail convidado",
                "invitation.contacts.code": "código",
                "invitation.contacts.no_sent_invitations": "Ainda não enviei convites.",
                "invitation.contacts.simulated_rewards": "Recompensas simuladas obtidas",
                "invitation.contacts.no_simulated_rewards": "Ainda não há recompensas simuladas.",
                "common.id": "EU IA",
                "common.created": "Criado",
                'plan.pro_contacts': 'Até 100 contatos por usuário',
                "common.status": "Status",
                "login.prompt_create_account_with_name": "Quer criar uma conta com este nome?",
                'plans.upgrade.title': 'Atualizar plano',
                'plans.upgrade.comparison': 'Comparação de planos',
                'plans.upgrade.billing': '',
                'plans.upgrade.cancel_anytime': 'Cancele quando quiser',
                'plans.actions.upgrade_pro': 'Atualizar para PRO',
                'plans.actions.become_founder': 'Tornar-se Founder',

                'plans.modal.card.current_badge': 'Seu plano atual',

                'plans.modal.card.lower_tier': 'Abaixo do seu plano ativo',

                'plans.modal.card.manage_in_profile': 'Para alterar ou cancelar: Assinatura e faturamento no seu perfil.',
                'plans.modal.card.cancel_subscription': 'Cancelar assinatura',
                'plans.modal.cancel_confirm.title': 'Cancelar ou gerir assinatura',
                'plans.modal.cancel_confirm.body': 'Um novo separador abrirá o portal seguro da Paddle para atualizar pagamento, faturas ou cancelar a assinatura.',
                "plans.modal.cancel_confirm.continue_button": "Continuar",
                'plans.modal.cancel_confirm.back_button': 'Voltar',
                'plans.modal.cancel_paddle_fallback.title': 'Gerir a sua assinatura',
                'plans.modal.cancel_paddle_fallback.body': 'O portal de faturação Paddle não abre neste ambiente (ex.: desenvolvimento local ou conta ainda não associada). Pode continuar a ver e comparar planos aqui.',
                'plans.modal.cancel_paddle_fallback.confirm': 'Entendi',
                'plans.upgrade_required': 'Disponível no plano PRO',
                'settings.heading': 'Configurações',
                "settings.dashboard": "Painel",
                'settings.dashboardDescription': 'Preferências locais do painel inicial e dos blocos visíveis.',
                'settings.dashboardGridHeading': 'Blocos do painel',
                'settings.dashboardShowOnStartDescription': 'Se ativado, o painel abre após o login em vez da lista de contactos.',
                'settings.dashboardBlockWelcome': 'Boas-vindas',
                'settings.dashboardBlockUsage': 'Uso do plano',
                'settings.dashboardBlockFiles': 'Meus ficheiros',
                'settings.dashboardBlockPromotions': 'Promoções',
                'settings.dashboardBlockSessions': 'Sessões',
                'settings.dashboardWelcomeDescription': 'Primeiros passos, convidar contacto e atalhos de ajuda.',
                'settings.dashboardUsageDescription': 'Uso face aos limites: contactos, caracteres, armazenamento e dispositivos.',
                'settings.dashboardFilesDescription': 'Resumo de ficheiros visíveis e espaço em Meus ficheiros.',
                'settings.dashboardPromotionsDescription': 'Resumo de promoções e ligação ao programa.',
                'settings.dashboardSessionsDescription': 'Sessões e dispositivos ativos; pode fechar outras sessões se aplicável.',
                'settings.enabled': 'Ativo',
                'settings.disabled': 'Inativo',
                'settings.showDashboardOnStart': 'Mostrar o painel ao iniciar',
                'settings.showWelcomeBlock': 'Mostrar bloco de boas-vindas',
                'settings.showPromotionsBlock': 'Mostrar bloco de promoções',
                'settings.showUsageBlock': 'Mostrar uso do plano',
                'settings.showRecentConversationsBlock': 'Mostrar conversas recentes (última mensagem por contacto)',
                'settings.showSessionsBlock': 'Mostrar sessões ativas',
                'settings.showFilesBlock': 'Mostrar resumo de ficheiros',
                'settings.dashboardLocalNote': 'Estas preferências ficam no navegador (local) até existir API de perfil.',
                'settings.appearanceSettings': 'Aparência',
                "settings.argentinaTheme": "Tema Argentina",
                'settings.darkMode': 'Modo escuro',
                "settings.language": "Linguagem",
                'settings.messageSound': 'Som de mensagens',
                'settings.playSoundDescription': 'Reproduzir um som para mensagens novas ou alertas importantes.',
                'settings.messageSoundEnabled': 'Ligado',
                'settings.messageSoundDisabled': 'Desligado',
                'settings.accountSettings': 'Conta',
                'settings.deleteAccount': 'Eliminar conta',
                'settings.deleteAccountWarning': 'Isto é permanente. Os seus dados, mensagens, contactos e definições serão removidos de acordo com o processo de eliminação da plataforma.',
                'settings.deleteMyAccount': 'Eliminar a minha conta',
                'dashboard.contacts': 'Contatos',
                "dashboard.characters": "Personagens",
                'dashboard.storage': 'Armazenamento',
                'dashboard.active_devices': 'Dispositivos ativos',
                'dashboard.need_more_resources': 'Precisa de mais recursos?',
                'dashboard.upgrade_message': 'Atualize seu plano para obter mais contatos, caracteres, armazenamento e dispositivos ativos.',
                'dashboard.upgrade_button': 'Migrar para PRO',
                'dashboard.upgrade_button_pro': 'Migrar para PRO',
                'dashboard.upgrade_button_foundation': 'Migrar para FOUNDATION',
                'files.preview': 'Pré-visualização',
                'files.previewFile': 'Pré-visualização do ficheiro',
                'files.previewUnavailable': 'Pré-visualização indisponível.',
                'files.previewLoading': 'A carregar pré-visualização…',
                'files.openPreview': 'Pré-visualizar',
                'files.downloadFile': 'Descarregar ficheiro',
                'files.downloadFailed': 'Não foi possível descarregar o ficheiro. Verifique a ligação e a sessão e tente novamente.',
                'files.closePreview': 'Fechar pré-visualização',
                'files.unsupportedPreview': 'Sem pré-visualização para este tipo de ficheiro. Pode ver os detalhes ou descarregar.',
                'files.pdfPreviewHelp': 'O navegador pode não mostrar o PDF integrado. Use descarregar para abrir.',
                "files.labelFileType": "Cara",
                'files.previewForbidden': 'Sem permissão para pré-visualizar.',
                'files.previewNotFound': 'Ficheiro indisponível ou já não visível na sua conta.',
                'files.unavailableForFree': 'Os meus ficheiros não está incluído no plano FREE.',
                'files.availableInFoundationAndPro': 'Os meus ficheiros está disponível em FOUNDATION e PRO.',
                'files.filesFeatureRestricted': 'Esta funcionalidade não está disponível no seu plano atual.',
                'files.filesLoadError': 'Erro ao carregar ficheiros.',
                'files.uploadUnavailableForFree': 'O envio de ficheiros não está disponível no plano FREE.',
                'files.uploadAvailableInFoundationAndPro': 'O envio de ficheiros está disponível em FOUNDATION e PRO.',
                'files.recipientStorageFull': 'O destinatário não tem espaço disponível para receber este ficheiro.',
                'files.recipientNoAvailableStorage': 'O destinatário não tem espaço disponível para receber este ficheiro.',
                'files.storageQuotaExceeded': 'Atingiu o limite de armazenamento do seu plano.',
                'files.freeStorageLimit': 'O plano FREE inclui 5 MB de armazenamento para ficheiros recebidos.',
                'settings.unreadEmailReminderSection': 'Resumo por e-mail (não lidas)',
                'settings.unreadEmailReminderDescription': 'Se deixar mensagens ou ficheiros novos sem ler mais tempo do que abaixo, o ArChat envia um único resumo por e-mail (não um por mensagem).',
                'settings.unreadEmailReminderToggle': 'Enviar resumos por e-mail',
                "settings.unreadEmailDelayHours": "Aguarde antes de enviar (horas)",
                'settings.unreadEmailDelayHint': '1–168 horas (até uma semana). O e-mail usa o idioma do perfil.',
                'subjects.title': 'Assuntos',
                'subjects.singular': 'Assunto',
                'subjects.plural': 'Assuntos',
                'subjects.general': 'Geral',
                'subjects.new': 'Novo assunto',
                'subjects.create': 'Criar assunto',
                'subjects.rename': 'Renomear',
                'subjects.finish': 'Concluir',
                "subjects.reopen": "Reabrir",
                "subjects.select": "Continuar",
                'subjects.status.open': 'Aberto',
                'subjects.status.pending': 'Pendente',
                'subjects.status.finished': 'Concluído',
                'subjects.limitReached': 'Atingiu o limite de assuntos ativos nesta conversa. Conclua um assunto para criar outro.',
                'subjects.limitReachedFree': 'O plano FREE permite até 3 assuntos ativos por conversa. Conclua um assunto para criar outro.',
                'subjects.limitReachedPro': 'O plano PRO permite até 5 assuntos ativos por conversa. Conclua um assunto para criar outro.',
                'subjects.limitReachedFoundation': 'O plano FOUNDATION permite até 5 assuntos ativos por conversa. Conclua um assunto para criar outro.',
                'subjects.activeLimitsLine': 'Assuntos ativos: {current} / {max}',
                'subjects.closedListTitle': 'Assuntos encerrados',
                'subjects.viewClosed': 'Ver assuntos encerrados',
                'subjects.noClosedSubjects': 'Não há assuntos encerrados.',
                "subjects.reopenSubject": "Reabrir",
                'subjects.reopenedSubjects': 'Assuntos reabertos',
                "subjects.reopenLimitReached": `subject.ownerOnlyReopen': 'Somente a pessoa que criou o assunto pode reabri-lo.`,
                'subjects.ownerOnlyReopen': 'Somente quem criou este assunto pode reabri-lo.',
                'subjects.modal.title': 'Assuntos da conversa',
                'subjects.modal.subtitle': 'Escolha ou gerencie os assuntos desta conversa.',
                'subjects.contactLabel': 'CONTATO:',
                'subjects.ownerOnlyRename': 'Apenas quem criou o assunto pode alterar o nome.',
                'subjects.ownerOnlyStateChange': 'Apenas quem criou o assunto pode alterar o estado.',
                'subjects.createdByOther': 'Este assunto foi criado pela outra parte. Você pode responder, mas não renomear.',
                'subjects.empty': 'Não há assuntos para mostrar.',
                'subjects.noResults': 'Nenhum assunto encontrado.',
                'subjects.error.generic': 'Não foi possível concluir a ação. Tente novamente.',
                'subjects.error.featureDisabled': 'Assuntos não estão disponíveis neste ambiente.',
                'subjects.error.duplicateName': 'Já existe um assunto ativo com esse nome.',
                'subjects.error.ownerRequired': 'Você não tem permissão para modificar este assunto.',
                'subjects.error.defaultCannotRename': 'O assunto Geral não pode ser renomeado.',
                'subjects.error.defaultCannotFinish': 'O assunto Geral não pode ser concluído.',
                'subjects.current': 'Assunto',
                'subjects.change': 'Alterar assunto',
                'subjects.currentLabel': 'Assunto:',
                'subjects.changeSubject': 'Alterar assunto',
                'subjects.closedCannotSend': 'Este assunto está encerrado. Reabra-o para enviar novas mensagens.',
                'subjects.selectBeforeSend': 'Escolha um assunto no modal para ver as mensagens e enviar.',
                'subjects.loadingMessages': 'A carregar mensagens deste assunto…',
                'subjects.messageFilterError': 'Não foi possível carregar as mensagens para este assunto.',

                // Tags
                "tags.etiquetas": "rótulos",
                "tags.manageTitle": "Gerenciar tags",
                "tags.manage": "🏷️ Etiquetas",
                "tags.allTags": "Todas as tags",
                "tags.confirmDelete": "Excluir esta tag?",
                "tags.tagNamePlaceholder": "Nome da etiqueta",
                "tags.create": "Criar",
                "tags.noTags": "Sem tags. Crie um acima.",
                "tags.save": "Salvar",
                "tags.edit": "Editar",
                "tags.delete": "Excluir",
                "tags.assignTo": "Atribuir a",
                "tags.noTagsToAssign": "Nenhuma etiqueta disponível. Crie-os primeiro.",
                // Templates
                "templates.selectTitle": "Modelos",
                "templates.noTemplates": "Sem modelos. Crie um acima.",
                "templates.manage": "Gerenciar modelos",
                "templates.confirmDelete": "Excluir este modelo?",
                "templates.manageTitle": "Gerenciar modelos",
                "templates.titlePlaceholder": "Título do modelo",
                "templates.bodyPlaceholder": "Escreva o modelo de mensagem...",
                "templates.create": "Criar modelo",
                "templates.save": "Salvar",
                "templates.edit": "Editar",
                "templates.delete": "Excluir",
                // Tags (added)
                "tags.bgColor": "Cor de fundo",
                "tags.textColor": "Cor do texto",
                "tags.selectTag": "Selecione uma etiqueta",
                // Web Push notifications
                "settings.webPushSection": "Notificações do sistema (Web Push/PWA)",
                "settings.webPushDescription": "Permite alertas quando o app está em segundo plano ou fechado no celular. Requer chave pública VAPID na compilação (VITE_VAPID_PUBLIC_KEY) e chaves do servidor. Concede permissão ao navegador e registra este dispositivo.",
                "settings.webPushButton": "Habilitar notificações push",
                "settings.webPushRegistering": "Registrando…",
                "settings.webPushState.granted": "Permissão concedida. Se VAPID estiver configurado, a assinatura foi enviada ao servidor.",
                "settings.webPushState.denied": "Permissão negada. Habilite notificações para este site nas configurações do navegador.",
                "settings.webPushState.default": "Toque no botão para solicitar permissão e registrar este dispositivo.",
                "settings.webPushState.unsupported": "Este navegador não suporta Web Push.",
                "settings.webPushVapidMissing": "VITE_VAPID_PUBLIC_KEY está faltando nesta construção de front-end: a assinatura push não pode ser concluída.",
                ...PRESET_LOCALES.pt,
                "auth.login.clear_password_lock_after_reset": "Já alterei minha senha (por exemplo, em outro dispositivo)",
                "auth.signup_disabled": "O registro de novas contas está temporariamente desativado neste ambiente.",
                "auth.reset_user_not_found": "Não encontramos uma conta associada a esse e-mail. Verifique se está escrito corretamente ou crie uma nova conta.",
                "account.not_found": "Conta não encontrada.",
                "auth.pending_activation.title": "Ativação pendente da conta",
                "auth.pending_activation.body": "Sua conta ainda não está ativada. Verifique seu e-mail e confirme seu cadastro para entrar no ArChat.",
                "auth.pending_activation.back_to_login": "Voltar ao login",
                "auth.pending_activation.support_prefix": "Você precisa de ajuda? Contate o suporte:",
                "auth.pending_activation.support_email": "info@archat.com.ar",
                "auth.pending_activation.email_label": "Email para reenviar ativação",
                "auth.pending_activation.email_placeholder": "tu@email.com",
                "auth.pending_activation.email_required": "Digite o e-mail com o qual você se registrou para reenviar a ativação.",
                "auth.pending_activation.sent_title": "E-mail de ativação enviado",
                "auth.pending_activation.sent_body": "Se o e-mail corresponder a uma conta pendente, enviaremos um novo link de ativação. Verifique sua caixa de entrada e também spam ou lixo eletrônico.",
                "auth.pending_activation.soft_error_title": "Reenviar não disponível",
                "auth.pending_activation.soft_error_body": "Não foi possível processar o reenvio neste momento. Tente novamente em alguns minutos ou escreva para info@archat.com.ar.",
                "auth.pending_activation.resend_again": "Reenviar novamente",
                "menu.plans": "Planos",
                "files.title": "meus arquivos",
                "files.filter_all": "Todos",
                "files.filter_sent": "Enviado",
                "files.filter_received": "Recebido",
                "files.filter_images": "Imagens",
                "files.filter_documents": "Documentos",
                "files.col_name": "Nome",
                "files.col_size": "Tamanho",
                "files.col_date": "Data",
                "files.col_direction": "Dir.",
                "files.col_actions": "Ações",
                "files.sent": "📤 Enviado",
                "files.received": "📥 Recebido",
                "files.download": "Descarga",
                "files.delete_for_me": "Excluir para mim",
                "files.delete_confirm_title": "Excluir arquivo",
                "files.delete_confirm_message": "Este arquivo será excluído da sua conta. Ele não será excluído para a outra pessoa. Continuar?",
                "files.empty": "Você não tem arquivos.",
                "files.error_loading": "Erro ao enviar arquivos.",
                "files.load_more": "Carregar mais",
                "message.status.sending": "Enviando…",
                "message.status.failed": "Não enviado",
                "message.status.sent": "Enviado",
                "message.status.delivered": "Entregue",
                "message.status.read": "Ler",
                "home.public_nav.pricing": "Preços",
                "home.public_nav.aria": "Navegação principal do site",
                "home.public_footer.aria": "Links legais",
                "home.pricing_link": "Planos e preços",
                "publicPricing.nav.back_home": "← Página inicial",
                "publicPricing.title": "Planos e preços",
                "publicPricing.subtitle": "Limites transparentes e alinhados ao mecanismo de assinatura ArChat. Preços comerciais em dólares americanos para checkout internacional (ex. Paddle).",
                "publicPricing.commercial_note": "Os limites funcionais vêm de PlanConstants/PlanResolver; sua conta pode aplicar plan_limits no banco de dados. A cobrança do comerciante usa Paddle (ou outros processadores oficialmente designados pela ArChat) com preços em dólares americanos conforme indicado.",
                "publicPricing.plan.free": "FREE",
                "publicPricing.plan.foundation": "FOUNDATION",
                "publicPricing.plan.pro": "PRO",
                "publicPricing.price.free": "USD 0 / mes",
                "publicPricing.price.foundation": "USD {price} / mes",
                "publicPricing.price.pro": "USD {price} / mes",
                "publicPricing.same_limits_pro": "Mesmos limites técnicos do PRO (contrato premium).",
                "publicPricing.same_limits_foundation": "Mesmos limites técnicos do FOUNDATION (contrato premium).",
                "publicPricing.badge.foundation": "Programa Founder",
                "publicPricing.badge.pro": "Recomendado",
                "publicPricing.free.b1": "30.000 caracteres por mês por conta.",
                "publicPricing.free.b2": "Até 2 contatos por usuário; até 2 conversas ativas por conta.",
                "publicPricing.free.b3": "Sem anexos ou espaço de armazenamento; sem exportação de dados.",
                "publicPricing.free.b4": "Histórico de mensagens de até 30 dias; 1 dispositivo por usuário.",
                "publicPricing.free.b5": "34 mensagens/dia e 1.000 mensagens/mês (locatário); até 20 convites por dia.",
                "publicPricing.premium.b1": "300.000 caracteres por mês por conta; até 100 contatos por usuário.",
                "publicPricing.premium.b2": "Conversas e chats ilimitados (inquilino); 1.667 mensagens/dia e 50 mil/mês.",
                "publicPricing.premium.b3": "Até 50 MB de armazenamento (locatário); até 3 dispositivos por usuário.",
                "publicPricing.premium.b4": "Convites ilimitados (inquilino); exportação, tradução automática e arquivos conforme planejado.",
                "publicPricing.premium.b5": "FOUNDATION: mesmo contrato técnico do PRO, mais programa Founder (150 vagas). PRO: padrão premium.",
                "publicPricing.foundation.founder_note": "Programa comercial fundador: número limitado de {slots} vagas (ver resumo do plano). Os mesmos limites PRO quando a assinatura é ativada.",
                "publicPricing.cta.start_free": "Crie uma conta gratuita",
                "publicPricing.cta.register_paid": "Criar uma conta",
                "publicPricing.paddle_hint": "A finalização da compra com o processador escolhido será concluída dentro do aplicativo quando o carregamento estiver habilitado.",
                "publicPricing.legal.nav_label": "Jurídico",
                "publicPricing.legal.terms": "Termos de serviço",
                "publicPricing.legal.privacy": "política de Privacidade",
                "publicPricing.legal.refund": "Política de Reembolso",
                "profile.security.privacy_note": "Gerencie a privacidade e a segurança da sua conta.",
                "profile.security.sessions_title": "Sessões ativas",
                "profile.security.current": "Sessão atual",
                "profile.plan.foundation.description": "Plano FOUNDATION (Founder): mesma utilização premium do PRO, com programa Founder e vagas limitadas (150 vagas).",
                "billing.view_plans": "Ver planos",
                "billing.paddle.cancel_via_portal": "Cancelar assinatura",
                "billing.paddle.test_access_denied_body": "Neste servidor as operações de cobrança são restritas (modo de teste ou lista de testes). Se você já pagou com uma conta real, na produção o pagamento deverá ser permitido para todos os usuários (por exemplo, PAYMENTS_ALLOW_ALL_BILLING_USERS) ou essa restrição deverá ser desativada. Entre em contato com o suporte.",
                "attachment.storage_insufficient_precheck.title": "Espaço insuficiente",
                "attachment.storage_insufficient_precheck.message": "O arquivo pesa {fileSizeMb} MB e você só tem {availableMb} MB disponíveis. Libere espaço ou melhore seu plano para continuar.",
                "attachment.files_disabled.title": "Limite do plano",
                "attachment.files_disabled.message": "Seu plano atual não inclui envio de arquivos. Melhore seu plano para continuar.",
                "contacts.viewContactInfo": "Ver detalhes de contato",
                "contacts.contactInfoTitle": "Detalhes de contato",
                "contacts.phone": "Telefone",
                "contacts.bio": "Biografia",
                "contacts.notProvided": "Desinformado",
                "contacts.unread.badge": "Mensagens não lidas",
                "dashboard.recentInbound.title": "Últimas mensagens recebidas",
                "dashboard.recentInbound.empty": "Você não tem mensagens recebidas recentemente.",
                "dashboard.recentInbound.error": "Não foi possível carregar as mensagens.",
                "dashboard.recentInbound.previewPhoto": "Foto",
                "dashboard.recentInbound.previewFile": "Arquivo",
                "dashboard.recentInbound.previewPdf": "PDF",
                "dashboard.recentInbound.previewUnavailable": "Mensagem não disponível",
                "dashboard.recentInbound.readTitle": "Ler",
                "dashboard.recentInbound.unreadTitle": "não lido",
                "dashboard.recentConversations.title": "Conversas recentes",
                "dashboard.recentConversations.empty": "Não há conversas para mostrar.",
                "dashboard.recentConversations.error": "Não foi possível carregar as conversas.",
                "dashboard.plan.foundation": "FOUNDATION",
                "plan.errors.translationNotAllowed.title": "Tradução não disponível",
                "plan.errors.translationNotAllowed.message": "Seu plano atual não inclui tradução automática entre idiomas.",
                "plan.errors.translationNotAllowed.solution": "Para usar a tradução automática, atualize seu plano.",
                "billing.subscription.cancel_scheduled_date": "Sua assinatura está programada para ser cancelada em {{date}}. Você pode continuar usando seu plano até então.",
                "billing.subscription.cancel_scheduled_badge": "Cancelado em {{date}}",
                "billing.scheduled.plan_after_cancel_label": "Planeje no final do período:",
                "billing.scheduled.plan_free": "FREE (gratuito)",
                "billing.scheduled.plan_foundation": "FOUNDATION",
                "billing.scheduled.switch_to_foundation": "Mudar para FUNDAÇÃO",
                "billing.scheduled.switch_to_free": "Mudar para GRATUITO",
                "billing.scheduled.foundation_full_title": "FUNDAÇÃO não disponível",
                "billing.scheduled.foundation_full_message": "Não há vagas para a FUNDAÇÃO disponíveis no momento. Seu plano será reduzido para GRATUITO no final do período.",
                "billing.scheduled.saving": "Salvando...",
                "billing.scheduled.error_title": "Erro ao alterar plano",
                "billing.scheduled.error_generic": "O plano programado não pôde ser alterado. Tente novamente.",
                "billing.cancel_scheduled.title": "Cancelamento programado",
                "billing.cancel_scheduled.desc": "Sua assinatura será cancelada em {{date}}. Você pode continuar usando seu plano atual até então.",
                "billing.cancel_scheduled.no_new_plan_until_end": "Até que esta assinatura expire você não poderá contratar outro plano.",
                "billing.cancel_scheduled.free_fallback": "Caso não renove nenhum plano, sua conta continuará GRATUITA com as limitações correspondentes.",
                "billing.cancel_scheduled.profile_deactivation_hint": "Você também pode cancelar a assinatura da plataforma a partir do seu perfil.",
                "billing.cancel_scheduled.default_free": "No final do período: GRATUITO",
                "google.missing_client_id": "O Login do Google não está disponível nesta versão: VITE_GOOGLE_CLIENT_ID (ou googleClientId por locatário em __ARCHAT_TENANT_CONFIG__) está ausente.",
                "reviews.title": "Avaliações do ArChat",
                "reviews.create_title": "Como você avaliaria o ArChat?",
                "reviews.edit_title": "Editar meu comentário",
                "reviews.comment_placeholder": "Conte-nos sobre sua experiência (opcional)...",
                "reviews.submit_btn": "Enviar avaliação",
                "reviews.update_btn": "Atualizar",
                "reviews.thank_you": "Obrigado pela sua avaliação!",
                "reviews.submitted_message": "Sua opinião nos ajuda a melhorar.",
                "reviews.error_select_rating": "Selecione uma classificação",
                "reviews.error_generic": "Erro ao enviar avaliação",
                "reviews.prompt_message": "Você gosta do ArChat? Deixe sua avaliação!",
                "reviews.rate_now": "Qualificar",
                "reviews.later": "Mais tarde",
                "reviews.write_review": "Escrever comentário",
                "reviews.edit_my_review": "Editar meu comentário",
                "reviews.no_reviews": "Ainda não há comentários. Seja o primeiro!",
                "reviews.review_singular": "análise",
                "reviews.review_plural": "comentários",
                "reviews.verified": "Verificado",
                "reviews.anonymous": "Anônimo",
                "files.storageUsed": "Espaço usado",
                "files.planQuota": "Cota do plano",
                "files.availableStorage": "Disponível",
                "files.usagePercent": "usado",
                "files.unlimited": "Ilimitado",
                "files.sentBy": "Enviado por",
                "files.unknownUser": "Usuário",
};


